import React__default, { createElement, useEffect, Fragment, useState, useRef, useLayoutEffect, useMemo, forwardRef } from 'react';
import { Transition, Menu, Dialog, Popover as Popover$1, Switch, Combobox as Combobox$1 } from '@headlessui/react';
import cx from 'classnames';
import { extendTailwindMerge, validators } from 'tailwind-merge';
import { DataGrid } from '@mui/x-data-grid';
export * from '@mui/x-data-grid';
import CheckIcon from '@icons/check-icon.svg';
import Checkbox$1 from '@mui/material/Checkbox';
import { debounce } from 'lodash-es';
import ReactDOM from 'react-dom';
import WarningIcon from '@icons/warning-icon.svg';
import { usePopper } from 'react-popper';
import CloseIcon from '@icons/close-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ChevronDownIcon from '@icons/chevron-down-icon.svg';
import SearchIcon from '@icons/search-icon.svg';
import { styled } from '@mui/system';
import { Autocomplete, TextField, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import CreatableSelect from 'react-select/creatable';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "*{border:0 solid #e5e7eb;box-sizing:border-box}@font-face{font-family:Reckless;font-style:normal;font-weight:400;src:url(assets/fonts/Reckless-Regular.woff) format(\"woff\"),url(assets/fonts/Reckless-Regular.woff2) format(\"woff2\")}@font-face{font-family:Reckless;font-style:normal;font-weight:500;src:url(assets/fonts/Reckless-Medium.woff) format(\"woff\"),url(assets/fonts/Reckless-Medium.woff2) format(\"woff2\")}*,:after,:before{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.container{width:100%}@media (min-width:640px){.container{max-width:640px}}@media (min-width:768px){.container{max-width:768px}}@media (min-width:1024px){.container{max-width:1024px}}@media (min-width:1280px){.container{max-width:1280px}}@media (min-width:1536px){.container{max-width:1536px}}.sr-only{clip:rect(0,0,0,0);border-width:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.pointer-events-none{pointer-events:none}.pointer-events-auto{pointer-events:auto}.visible{visibility:visible}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{left:0;right:0}.inset-0,.inset-y-0{bottom:0;top:0}.bottom-10{bottom:2.5rem}.left-0{left:0}.right-0{right:0}.right-3\\.5{right:.875rem}.top-1\\/2{top:50%}.right-3{right:.75rem}.top-0{top:0}.top-6{top:1.5rem}.right-6{right:1.5rem}.bottom-0{bottom:0}.left-3{left:.75rem}.top-4{top:1rem}.left-2\\.5{left:.625rem}.left-2{left:.5rem}.top-2{top:.5rem}.top-5{top:1.25rem}.right-5{right:1.25rem}.right-\\[52px\\]{right:52px}.top-7{top:1.75rem}.right-8{right:2rem}.right-16{right:4rem}.left-4{left:1rem}.right-4{right:1rem}.top-5\\.5{top:22px}.bottom-2{bottom:.5rem}.-right-3{right:-.75rem}.-left-3{left:-.75rem}.-bottom-2{bottom:-.5rem}.-top-2{top:-.5rem}.z-10{z-index:10}.z-50{z-index:50}.z-20{z-index:20}.-z-\\[1\\]{z-index:-1}.m-5{margin:1.25rem}.m-0{margin:0}.mx-1{margin-left:.25rem;margin-right:.25rem}.-mx-1\\.5{margin-left:-.375rem;margin-right:-.375rem}.-my-1\\.5{margin-bottom:-.375rem;margin-top:-.375rem}.-mx-1{margin-left:-.25rem;margin-right:-.25rem}.-my-1{margin-bottom:-.25rem;margin-top:-.25rem}.my-2{margin-bottom:.5rem;margin-top:.5rem}.mx-auto{margin-left:auto;margin-right:auto}.mx-10{margin-left:2.5rem;margin-right:2.5rem}.my-6{margin-bottom:1.5rem;margin-top:1.5rem}.my-1\\.5{margin-bottom:.375rem;margin-top:.375rem}.my-1{margin-bottom:.25rem;margin-top:.25rem}.mr-28{margin-right:7rem}.ml-3{margin-left:.75rem}.mb-0{margin-bottom:0}.mt-px{margin-top:1px}.mt-2{margin-top:.5rem}.ml-1{margin-left:.25rem}.mr-1{margin-right:.25rem}.ml-1\\.5{margin-left:.375rem}.mr-1\\.5{margin-right:.375rem}.ml-auto{margin-left:auto}.ml-2{margin-left:.5rem}.ml-6{margin-left:1.5rem}.mt-6{margin-top:1.5rem}.mb-\\[60px\\]{margin-bottom:60px}.mt-1{margin-top:.25rem}.mt-3{margin-top:.75rem}.box-border{box-sizing:border-box}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.contents{display:contents}.hidden{display:none}.\\!hidden{display:none!important}.h-fit{height:-moz-fit-content;height:fit-content}.h-4{height:1rem}.h-8{height:2rem}.h-full{height:100%}.h-3\\.5{height:.875rem}.h-3{height:.75rem}.h-5{height:1.25rem}.h-6{height:1.5rem}.h-10{height:2.5rem}.h-12{height:3rem}.h-\\[54px\\]{height:54px}.h-auto{height:auto}.h-px{height:1px}.h-2{height:.5rem}.h-7{height:1.75rem}.h-\\[400px\\]{height:400px}.max-h-48{max-height:12rem}.min-h-screen{min-height:100vh}.w-fit{width:-moz-fit-content;width:fit-content}.w-4{width:1rem}.w-48{width:12rem}.w-full{width:100%}.w-3\\.5{width:.875rem}.w-3{width:.75rem}.w-5{width:1.25rem}.w-52{width:13rem}.w-6{width:1.5rem}.w-\\[calc\\(100\\%_-_2\\.5rem\\)\\]{width:calc(100% - 2.5rem)}.w-10{width:2.5rem}.w-1\\/3{width:33.333333%}.w-auto{width:auto}.w-\\[150px\\]{width:150px}.w-16{width:4rem}.w-1\\/12{width:8.333333%}.w-1\\/4{width:25%}.w-1\\/2{width:50%}.w-3\\/4{width:75%}.w-11\\/12{width:91.666667%}.w-8{width:2rem}.w-\\[52px\\]{width:52px}.w-7{width:1.75rem}.w-\\[300px\\]{width:300px}.w-max{width:-moz-max-content;width:max-content}.min-w-\\[75px\\]{min-width:75px}.min-w-\\[80px\\]{min-width:80px}.min-w-\\[95px\\]{min-width:95px}.min-w-0{min-width:0}.max-w-full{max-width:100%}.max-w-none{max-width:none}.flex-1{flex:1 1 0%}.shrink-0{flex-shrink:0}.grow{flex-grow:1}.origin-top-right{transform-origin:top right}.-translate-y-1\\/2{--tw-translate-y:-50%}.-translate-y-1\\/2,.translate-x-full{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-full{--tw-translate-x:100%}.translate-x-0{--tw-translate-x:0px}.translate-x-0,.translate-y-full{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-full{--tw-translate-y:100%}.translate-y-0{--tw-translate-y:0px}.translate-x-2,.translate-y-0{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-2{--tw-translate-x:0.5rem}.translate-x-\\[-4px\\]{--tw-translate-x:-4px}.translate-x-4,.translate-x-\\[-4px\\]{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-4{--tw-translate-x:1rem}.-rotate-90{--tw-rotate:-90deg}.-rotate-90,.rotate-90{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-90{--tw-rotate:90deg}.rotate-\\[270deg\\]{--tw-rotate:270deg}.rotate-180,.rotate-\\[270deg\\]{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-180{--tw-rotate:180deg}.rotate-0{--tw-rotate:0deg}.rotate-0,.scale-95{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scale-95{--tw-scale-x:.95;--tw-scale-y:.95}.scale-100{--tw-scale-x:1;--tw-scale-y:1}.scale-100,.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes spin{to{transform:rotate(1turn)}}.animate-spin{animation:spin 1s linear infinite}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}.cursor-pointer{cursor:pointer}.cursor-default{cursor:default}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.resize{resize:both}.list-none{list-style-type:none}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-col{flex-direction:column}.flex-col-reverse{flex-direction:column-reverse}.content-center{align-content:center}.items-start{align-items:flex-start}.items-center{align-items:center}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-2{gap:.5rem}.gap-4{gap:1rem}.gap-3{gap:.75rem}.gap-1{gap:.25rem}.gap-6{gap:1.5rem}.gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.gap-x-5{-moz-column-gap:1.25rem;column-gap:1.25rem}.gap-y-2{row-gap:.5rem}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse:0;border-bottom-width:calc(1px*var(--tw-divide-y-reverse));border-top-width:calc(1px*(1 - var(--tw-divide-y-reverse)))}.divide-gray-600>:not([hidden])~:not([hidden]){--tw-divide-opacity:1;border-color:rgb(110 110 110/var(--tw-divide-opacity))}.self-start{align-self:flex-start}.self-center{align-self:center}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-visible{overflow:visible}.overflow-y-auto{overflow-y:auto}.truncate{overflow:hidden;white-space:nowrap}.text-ellipsis,.truncate{text-overflow:ellipsis}.whitespace-normal{white-space:normal}.rounded-xl{border-radius:.75rem}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-\\[10px\\]{border-radius:10px}.rounded-full{border-radius:9999px}.border{border-width:1px}.border-2{border-width:2px}.border-b-2{border-bottom-width:2px}.border-solid{border-style:solid}.border-dashed{border-style:dashed}.border-gray-300{border-color:rgb(223 223 223/var(--tw-border-opacity))}.border-gray-300,.border-gray-400{--tw-border-opacity:1}.border-gray-400{border-color:rgb(216 216 216/var(--tw-border-opacity))}.border-gray-200{border-color:rgb(238 238 238/var(--tw-border-opacity))}.border-gray-200,.border-gray-700{--tw-border-opacity:1}.border-gray-700{border-color:rgb(17 17 17/var(--tw-border-opacity))}.border-gray-500{--tw-border-opacity:1;border-color:rgb(162 162 162/var(--tw-border-opacity))}.border-transparent{border-color:transparent}.border-teal-250{border-color:rgb(52 130 156/var(--tw-border-opacity))}.border-red-300,.border-teal-250{--tw-border-opacity:1}.border-red-300{border-color:rgb(227 79 47/var(--tw-border-opacity))}.border-orange-300{--tw-border-opacity:1;border-color:rgb(250 144 67/var(--tw-border-opacity))}.bg-gray-700{background-color:rgb(17 17 17/var(--tw-bg-opacity))}.bg-gray-100,.bg-gray-700{--tw-bg-opacity:1}.bg-gray-100{background-color:rgb(246 246 246/var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-gray-400{background-color:rgb(216 216 216/var(--tw-bg-opacity))}.bg-gray-200,.bg-gray-400{--tw-bg-opacity:1}.bg-gray-200{background-color:rgb(238 238 238/var(--tw-bg-opacity))}.bg-green-100{background-color:rgb(233 243 238/var(--tw-bg-opacity))}.bg-green-100,.bg-red-100{--tw-bg-opacity:1}.bg-red-100{background-color:rgb(251 234 233/var(--tw-bg-opacity))}.bg-orange-100{background-color:rgb(254 239 226/var(--tw-bg-opacity))}.bg-orange-100,.bg-teal-100{--tw-bg-opacity:1}.bg-teal-100{background-color:rgb(229 239 242/var(--tw-bg-opacity))}.bg-purple-100{background-color:rgb(244 239 255/var(--tw-bg-opacity))}.bg-green-200,.bg-purple-100{--tw-bg-opacity:1}.bg-green-200{background-color:rgb(213 233 222/var(--tw-bg-opacity))}.bg-orange-200{background-color:rgb(254 225 199/var(--tw-bg-opacity))}.bg-orange-200,.bg-red-200{--tw-bg-opacity:1}.bg-red-200{background-color:rgb(249 220 213/var(--tw-bg-opacity))}.bg-gray-50{background-color:rgb(247 246 245/var(--tw-bg-opacity))}.bg-gray-50,.bg-teal-200{--tw-bg-opacity:1}.bg-teal-200{background-color:rgb(204 225 231/var(--tw-bg-opacity))}.bg-plum-300{background-color:rgb(136 0 88/var(--tw-bg-opacity))}.bg-plum-200,.bg-plum-300{--tw-bg-opacity:1}.bg-plum-200{background-color:rgb(226 199 217/var(--tw-bg-opacity))}.bg-gray-650{background-color:rgb(72 72 72/var(--tw-bg-opacity))}.bg-gray-650,.bg-white{--tw-bg-opacity:1}.bg-white{background-color:rgb(255 255 255/var(--tw-bg-opacity))}.bg-red-300{background-color:rgb(227 79 47/var(--tw-bg-opacity))}.bg-gray-300,.bg-red-300{--tw-bg-opacity:1}.bg-gray-300{background-color:rgb(223 223 223/var(--tw-bg-opacity))}.fill-gray-700{fill:#111}.fill-white{fill:#fff}.p-4{padding:1rem}.p-1\\.5{padding:.375rem}.p-1{padding:.25rem}.p-6{padding:1.5rem}.p-5{padding:1.25rem}.p-0{padding:0}.p-7{padding:1.75rem}.p-8{padding:2rem}.p-3{padding:.75rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.py-3{padding-bottom:.75rem;padding-top:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.px-0{padding-left:0;padding-right:0}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-1{padding-left:.25rem;padding-right:.25rem}.py-0\\.5{padding-bottom:.125rem;padding-top:.125rem}.py-0{padding-bottom:0;padding-top:0}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-2{padding-left:.5rem;padding-right:.5rem}.py-1\\.5{padding-bottom:.375rem;padding-top:.375rem}.py-1{padding-bottom:.25rem;padding-top:.25rem}.px-3\\.5{padding-left:.875rem;padding-right:.875rem}.px-3{padding-left:.75rem;padding-right:.75rem}.py-2\\.5{padding-bottom:.625rem;padding-top:.625rem}.py-2{padding-bottom:.5rem;padding-top:.5rem}.py-3\\.5{padding-bottom:.875rem;padding-top:.875rem}.px-10{padding-left:2.5rem;padding-right:2.5rem}.py-8{padding-bottom:2rem;padding-top:2rem}.py-px{padding-bottom:1px;padding-top:1px}.pl-7{padding-left:1.75rem}.pr-10{padding-right:2.5rem}.pb-1\\.5{padding-bottom:.375rem}.pb-1{padding-bottom:.25rem}.pl-2{padding-left:.5rem}.pl-3{padding-left:.75rem}.pr-6{padding-right:1.5rem}.pr-5{padding-right:1.25rem}.pl-6{padding-left:1.5rem}.pl-4{padding-left:1rem}.pl-0{padding-left:0}.pt-1{padding-top:.25rem}.pt-6{padding-top:1.5rem}.pt-10{padding-top:2.5rem}.pb-10{padding-bottom:2.5rem}.pr-3{padding-right:.75rem}.pr-2\\.5{padding-right:.625rem}.pr-2{padding-right:.5rem}.pr-4{padding-right:1rem}.pb-2{padding-bottom:.5rem}.pt-2{padding-top:.5rem}.pt-5{padding-top:1.25rem}.pb-5{padding-bottom:1.25rem}.pl-5{padding-left:1.25rem}.pt-0{padding-top:0}.pb-6{padding-bottom:1.5rem}.pl-8{padding-left:2rem}.pr-8{padding-right:2rem}.pb-12{padding-bottom:3rem}.pt-3{padding-top:.75rem}.pb-0{padding-bottom:0}.pb-3{padding-bottom:.75rem}.text-left{text-align:left}.text-center{text-align:center}.font-body{font-family:Inter,sans-serif}.font-sans{font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji}.font-title{font-family:Reckless,serif}.text-3{font-size:16px;line-height:24px}.text-2{font-size:14px;line-height:20px}.text-1{font-size:12px;line-height:16px}.text-0{font-size:10px;line-height:14px}.text-4{font-size:18px;line-height:24px}.text-5{font-size:20px;letter-spacing:-.2px;line-height:28px}.text-6{font-size:28px;letter-spacing:-.6px;line-height:40px}.text-7{font-size:36px;letter-spacing:-1px;line-height:48px}.text-8{font-size:44px;line-height:60px}.text-9{font-size:56px;line-height:72px}.text-10{font-size:72px;line-height:92px}.font-medium{font-weight:500}.font-regular{font-weight:400}.font-semibold{font-weight:600}.font-bold{font-weight:700}.text-white{color:rgb(255 255 255/var(--tw-text-opacity))}.text-gray-500,.text-white{--tw-text-opacity:1}.text-gray-500{color:rgb(162 162 162/var(--tw-text-opacity))}.text-gray-600{color:rgb(110 110 110/var(--tw-text-opacity))}.text-gray-600,.text-gray-700{--tw-text-opacity:1}.text-gray-700{color:rgb(17 17 17/var(--tw-text-opacity))}.text-green-500{color:rgb(6 101 50/var(--tw-text-opacity))}.text-green-500,.text-red-500{--tw-text-opacity:1}.text-red-500{color:rgb(188 35 2/var(--tw-text-opacity))}.text-orange-500{color:rgb(198 95 21/var(--tw-text-opacity))}.text-orange-500,.text-teal-500{--tw-text-opacity:1}.text-teal-500{color:rgb(0 76 100/var(--tw-text-opacity))}.text-purple-500{color:rgb(80 36 174/var(--tw-text-opacity))}.text-green-300,.text-purple-500{--tw-text-opacity:1}.text-green-300{color:rgb(43 144 90/var(--tw-text-opacity))}.text-orange-300{color:rgb(250 144 67/var(--tw-text-opacity))}.text-orange-300,.text-red-300{--tw-text-opacity:1}.text-red-300{color:rgb(227 79 47/var(--tw-text-opacity))}.text-gray-200{color:rgb(238 238 238/var(--tw-text-opacity))}.text-gray-200,.text-teal-300{--tw-text-opacity:1}.text-teal-300{color:rgb(0 103 136/var(--tw-text-opacity))}.text-gray-300{color:rgb(223 223 223/var(--tw-text-opacity))}.text-gray-300,.text-gray-400{--tw-text-opacity:1}.text-gray-400{color:rgb(216 216 216/var(--tw-text-opacity))}.text-orange-400{--tw-text-opacity:1;color:rgb(222 116 39/var(--tw-text-opacity))}.underline{-webkit-text-decoration-line:underline;text-decoration-line:underline}.no-underline{-webkit-text-decoration-line:none;text-decoration-line:none}.placeholder-gray-600::-moz-placeholder{--tw-placeholder-opacity:1;color:rgb(110 110 110/var(--tw-placeholder-opacity))}.placeholder-gray-600::placeholder{--tw-placeholder-opacity:1;color:rgb(110 110 110/var(--tw-placeholder-opacity))}.opacity-0{opacity:0}.opacity-100{opacity:1}.shadow-z4{--tw-shadow:0px 5px 24px rgba(0,0,0,.12);--tw-shadow-colored:0px 5px 24px var(--tw-shadow-color)}.shadow-z3,.shadow-z4{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.shadow-z3{--tw-shadow:0px 0px 2px rgba(0,0,0,.2),0px 2px 10px rgba(0,0,0,.1);--tw-shadow-colored:0px 0px 2px var(--tw-shadow-color),0px 2px 10px var(--tw-shadow-color)}.shadow-z6{--tw-shadow:0px 0px 0px 2px rgba(52,130,156,.2);--tw-shadow-colored:0px 0px 0px 2px var(--tw-shadow-color)}.shadow-z5,.shadow-z6{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.shadow-z5{--tw-shadow:-10000px -10000px 0 20000px rgba(0,0,0,.4);--tw-shadow-colored:-10000px -10000px 0 20000px var(--tw-shadow-color)}.shadow-transparent{--tw-shadow-color:transparent;--tw-shadow:var(--tw-shadow-colored)}.outline-none{outline:2px solid transparent;outline-offset:2px}.outline{outline-style:solid}.ring-2{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.ring-green-500{--tw-ring-opacity:1;--tw-ring-color:rgb(6 101 50/var(--tw-ring-opacity))}.ring-orange-500{--tw-ring-opacity:1;--tw-ring-color:rgb(198 95 21/var(--tw-ring-opacity))}.ring-red-500{--tw-ring-opacity:1;--tw-ring-color:rgb(188 35 2/var(--tw-ring-opacity))}.ring-gray-600{--tw-ring-opacity:1;--tw-ring-color:rgb(110 110 110/var(--tw-ring-opacity))}.ring-teal-500{--tw-ring-opacity:1;--tw-ring-color:rgb(0 76 100/var(--tw-ring-opacity))}.ring-gray-700{--tw-ring-opacity:1;--tw-ring-color:rgb(17 17 17/var(--tw-ring-opacity))}.ring-offset-green-100{--tw-ring-offset-color:#e9f3ee}.ring-offset-red-100{--tw-ring-offset-color:#fbeae9}.ring-offset-gray-50{--tw-ring-offset-color:#f7f6f5}.ring-offset-teal-100{--tw-ring-offset-color:#e5eff2}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition-opacity{transition-duration:.15s;transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-text-decoration-color,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-text-decoration-color,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-all{transition-duration:.15s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1)}.duration-300{transition-duration:.3s}.duration-500{transition-duration:.5s}.duration-100{transition-duration:.1s}.duration-75{transition-duration:75ms}.duration-200{transition-duration:.2s}.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");.placeholder\\:text-gray-600::-moz-placeholder{--tw-text-opacity:1;color:rgb(110 110 110/var(--tw-text-opacity))}.placeholder\\:text-gray-600::placeholder{--tw-text-opacity:1;color:rgb(110 110 110/var(--tw-text-opacity))}.hover\\:box-border:hover{box-sizing:border-box}.hover\\:border:hover{border-width:1px}.hover\\:border-solid:hover{border-style:solid}.hover\\:border-gray-400:hover{--tw-border-opacity:1;border-color:rgb(216 216 216/var(--tw-border-opacity))}.hover\\:border-gray-500:hover{--tw-border-opacity:1;border-color:rgb(162 162 162/var(--tw-border-opacity))}.hover\\:bg-plum-400:hover{--tw-bg-opacity:1;background-color:rgb(113 0 73/var(--tw-bg-opacity))}.hover\\:bg-gray-675:hover{--tw-bg-opacity:1;background-color:rgb(51 51 51/var(--tw-bg-opacity))}.hover\\:bg-gray-250:hover{--tw-bg-opacity:1;background-color:rgb(230 230 230/var(--tw-bg-opacity))}.hover\\:bg-gray-625:hover{--tw-bg-opacity:1;background-color:rgb(90 90 90/var(--tw-bg-opacity))}.hover\\:bg-gray-100:hover{--tw-bg-opacity:1;background-color:rgb(246 246 246/var(--tw-bg-opacity))}.hover\\:bg-white:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.hover\\:bg-red-400:hover{--tw-bg-opacity:1;background-color:rgb(207 52 19/var(--tw-bg-opacity))}.hover\\:text-gray-400:hover{--tw-text-opacity:1;color:rgb(216 216 216/var(--tw-text-opacity))}.hover\\:text-gray-650:hover{--tw-text-opacity:1;color:rgb(72 72 72/var(--tw-text-opacity))}.hover\\:text-teal-400:hover{--tw-text-opacity:1;color:rgb(0 89 117/var(--tw-text-opacity))}.hover\\:text-gray-700:hover{--tw-text-opacity:1;color:rgb(17 17 17/var(--tw-text-opacity))}.focus\\:border-teal-250:focus{--tw-border-opacity:1;border-color:rgb(52 130 156/var(--tw-border-opacity))}.focus\\:shadow-z6:focus{--tw-shadow:0px 0px 0px 2px rgba(52,130,156,.2);--tw-shadow-colored:0px 0px 0px 2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-2:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.focus\\:ring-offset-2:focus{--tw-ring-offset-width:2px}.focus-visible\\:ring-2:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.focus-visible\\:ring-teal-300:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgb(0 103 136/var(--tw-ring-opacity))}.focus-visible\\:ring-offset-0:focus-visible{--tw-ring-offset-width:0px}.active\\:bg-plum-500:active{--tw-bg-opacity:1;background-color:rgb(95 0 61/var(--tw-bg-opacity))}.active\\:bg-gray-650:active{--tw-bg-opacity:1;background-color:rgb(72 72 72/var(--tw-bg-opacity))}.active\\:bg-gray-300:active{--tw-bg-opacity:1;background-color:rgb(223 223 223/var(--tw-bg-opacity))}.active\\:bg-gray-600:active{--tw-bg-opacity:1;background-color:rgb(110 110 110/var(--tw-bg-opacity))}.active\\:bg-gray-200:active{--tw-bg-opacity:1;background-color:rgb(238 238 238/var(--tw-bg-opacity))}.active\\:bg-red-500:active{--tw-bg-opacity:1;background-color:rgb(188 35 2/var(--tw-bg-opacity))}.active\\:bg-gray-100:active{--tw-bg-opacity:1;background-color:rgb(246 246 246/var(--tw-bg-opacity))}.active\\:text-gray-300:active{--tw-text-opacity:1;color:rgb(223 223 223/var(--tw-text-opacity))}.active\\:text-gray-600:active{--tw-text-opacity:1;color:rgb(110 110 110/var(--tw-text-opacity))}.active\\:text-gray-700:active{--tw-text-opacity:1;color:rgb(17 17 17/var(--tw-text-opacity))}.active\\:text-teal-500:active{--tw-text-opacity:1;color:rgb(0 76 100/var(--tw-text-opacity))}.disabled\\:bg-gray-100:disabled{--tw-bg-opacity:1;background-color:rgb(246 246 246/var(--tw-bg-opacity))}.disabled\\:text-gray-500:disabled{--tw-text-opacity:1;color:rgb(162 162 162/var(--tw-text-opacity))}.disabled\\:placeholder-gray-500:disabled::-moz-placeholder{--tw-placeholder-opacity:1;color:rgb(162 162 162/var(--tw-placeholder-opacity))}.disabled\\:placeholder-gray-500:disabled::placeholder{--tw-placeholder-opacity:1;color:rgb(162 162 162/var(--tw-placeholder-opacity))}@media (min-width:1024px){.lg\\:bottom-8{bottom:2rem}.lg\\:right-20{right:5rem}.lg\\:my-20{margin-bottom:5rem;margin-top:5rem}.lg\\:mx-1{margin-left:.25rem;margin-right:.25rem}.lg\\:mb-0{margin-bottom:0}.lg\\:mt-4{margin-top:1rem}.lg\\:flex{display:flex}.lg\\:h-4{height:1rem}.lg\\:w-full{width:100%}.lg\\:w-\\[750px\\]{width:750px}.lg\\:w-auto{width:auto}.lg\\:w-\\[600px\\]{width:600px}.lg\\:w-4{width:1rem}.lg\\:max-w-md{max-width:28rem}.lg\\:translate-y-0{--tw-translate-y:0px}.lg\\:scale-95,.lg\\:translate-y-0{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.lg\\:scale-95{--tw-scale-x:.95;--tw-scale-y:.95}.lg\\:scale-100{--tw-scale-x:1;--tw-scale-y:1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.lg\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.lg\\:flex-row{flex-direction:row}.lg\\:flex-row-reverse{flex-direction:row-reverse}.lg\\:flex-col{flex-direction:column}.lg\\:flex-col-reverse{flex-direction:column-reverse}.lg\\:items-end{align-items:flex-end}.lg\\:items-center{align-items:center}.lg\\:justify-start{justify-content:flex-start}.lg\\:justify-center{justify-content:center}.lg\\:justify-between{justify-content:space-between}.lg\\:overflow-auto{overflow:auto}.lg\\:overflow-hidden{overflow:hidden}.lg\\:rounded-xl{border-radius:.75rem}.lg\\:bg-gray-200{background-color:rgb(238 238 238/var(--tw-bg-opacity))}.lg\\:bg-gray-200,.lg\\:bg-white{--tw-bg-opacity:1}.lg\\:bg-white{background-color:rgb(255 255 255/var(--tw-bg-opacity))}.lg\\:px-3\\.5{padding-left:.875rem;padding-right:.875rem}.lg\\:px-3{padding-left:.75rem;padding-right:.75rem}.lg\\:px-0{padding-left:0;padding-right:0}.lg\\:py-1\\.5{padding-bottom:.375rem;padding-top:.375rem}.lg\\:py-1{padding-bottom:.25rem;padding-top:.25rem}.lg\\:px-2\\.5{padding-left:.625rem;padding-right:.625rem}.lg\\:px-2{padding-left:.5rem;padding-right:.5rem}.lg\\:pt-0{padding-top:0}.lg\\:pb-1\\.5{padding-bottom:.375rem}.lg\\:pb-1{padding-bottom:.25rem}.lg\\:pb-\\[67px\\]{padding-bottom:67px}.lg\\:text-2{font-size:14px;line-height:20px}.lg\\:text-4{font-size:18px}.lg\\:text-3,.lg\\:text-4{line-height:24px}.lg\\:text-3{font-size:16px}.lg\\:text-0{font-size:10px;line-height:14px}.lg\\:text-1{font-size:12px;line-height:16px}.lg\\:text-5{font-size:20px;letter-spacing:-.2px;line-height:28px}.lg\\:text-6{font-size:28px;letter-spacing:-.6px;line-height:40px}.lg\\:text-7{font-size:36px;letter-spacing:-1px;line-height:48px}.lg\\:text-8{font-size:44px;line-height:60px}.lg\\:text-9{font-size:56px;line-height:72px}.lg\\:text-10{font-size:72px;line-height:92px}.lg\\:opacity-0{opacity:0}.lg\\:opacity-100{opacity:1}.lg\\:shadow-z3{--tw-shadow:0px 0px 2px rgba(0,0,0,.2),0px 2px 10px rgba(0,0,0,.1);--tw-shadow-colored:0px 0px 2px var(--tw-shadow-color),0px 2px 10px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.lg\\:hover\\:bg-gray-100:hover{--tw-bg-opacity:1;background-color:rgb(246 246 246/var(--tw-bg-opacity))}.lg\\:active\\:bg-gray-200:active{--tw-bg-opacity:1;background-color:rgb(238 238 238/var(--tw-bg-opacity))}}";
styleInject(css_248z,{"insertAt":"top"});

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.251 2.251a.857.857 0 0 1 1.212 0L8 6.788l4.537-4.537a.857.857 0 1 1 1.212 1.212L9.212 8l4.537 4.537a.857.857 0 1 1-1.212 1.212L8 9.212 3.463 13.75a.857.857 0 1 1-1.212-1.212L6.788 8 2.25 3.463a.857.857 0 0 1 0-1.212Z",
    fill: "currentColor"
  })));
};

var twMergeCustom = /*#__PURE__*/extendTailwindMerge({
  classGroups: {
    'font-size': [{
      text: [validators.isInteger]
    }],
    'font-weight': [{
      font: ['regular', 'medium', 'semibold', 'bold']
    }],
    'font-family': [{
      font: ['title', 'body']
    }]
  }
});
var mergeClassNames = function mergeClassNames() {
  return twMergeCustom(cx.apply(void 0, arguments));
};

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/**
 * The given font size is for mobile, and by default, desktop sizes are one level lower. However,
 * this can be overridden on a per-case basis by passing in an alternate value for desktopSize.
 * The given font weight is the lightest weight corresponding to that variant (per the Figma),
 * and can similarly be overridden when a heavier weight is needed. */
var TYPOGRAPHY_DEFAULTS = {
  font: 'font-body',
  size: 'text-0',
  desktopSize: undefined,
  weight: 'font-regular'
};
var TYPOGRAPHY_VARIANTS = {
  'XS': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-body',
    size: 'text-0',
    weight: 'font-medium'
  }),
  'SM': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-body',
    size: 'text-1',
    desktopSize: 'lg:text-0',
    weight: 'font-regular'
  }),
  'BASE': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-body',
    size: 'text-2',
    desktopSize: 'lg:text-1',
    weight: 'font-regular'
  }),
  'LG-1': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-body',
    size: 'text-3',
    desktopSize: 'lg:text-2',
    weight: 'font-regular'
  }),
  'LG-2': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-body',
    size: 'text-4',
    desktopSize: 'lg:text-3',
    weight: 'font-medium'
  }),
  'XL': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-body',
    size: 'text-5',
    desktopSize: 'lg:text-4',
    weight: 'font-medium'
  }),
  '2XL': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-body',
    size: 'text-6',
    desktopSize: 'lg:text-5',
    weight: 'font-bold'
  }),
  '3XL': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-body',
    size: 'text-7',
    desktopSize: 'lg:text-6',
    weight: 'font-bold'
  }),
  '4XL': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-title',
    size: 'text-8',
    desktopSize: 'lg:text-7',
    weight: 'font-medium'
  }),
  '5XL': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-title',
    size: 'text-9',
    desktopSize: 'lg:text-8',
    weight: 'font-medium'
  }),
  '6XL': /*#__PURE__*/_extends$1({}, TYPOGRAPHY_DEFAULTS, {
    font: 'font-title',
    size: 'text-10',
    desktopSize: 'lg:text-9',
    weight: 'font-medium'
  })
};

var Typography = function Typography(_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'p' : _ref$as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$hidden = _ref.hidden,
    hidden = _ref$hidden === void 0 ? false : _ref$hidden,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'LG-1' : _ref$variant,
    _ref$font = _ref.font,
    font = _ref$font === void 0 ? TYPOGRAPHY_VARIANTS[variant].font : _ref$font,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? TYPOGRAPHY_VARIANTS[variant].weight : _ref$weight,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? TYPOGRAPHY_VARIANTS[variant].size : _ref$size,
    _ref$desktopSize = _ref.desktopSize,
    desktopSize = _ref$desktopSize === void 0 ? TYPOGRAPHY_VARIANTS[variant].desktopSize : _ref$desktopSize;
  var CustomTag = as;
  return React__default.createElement(CustomTag, {
    className: twMergeCustom(cx(font, weight, size, desktopSize), className),
    hidden: hidden
  }, children);
};

var Loading = function Loading(_ref) {
  var isDark = _ref.isDark,
    className = _ref.className,
    hidden = _ref.hidden;
  return React__default.createElement("div", {
    className: cx('text-center', className),
    hidden: hidden
  }, React__default.createElement("div", {
    role: "status",
    className: "flex items-center justify-center"
  }, React__default.createElement("svg", {
    className: cx('inline w-5 h-5 animate-spin', isDark ? 'text-white fill-gray-700' : 'text-gray-700 fill-white'),
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7814 11C16.2825 11 15.8656 11.3644 15.7128 11.8393C14.9362 14.2532 12.6721 16 10 16C6.68629 16 4 13.3137 4 10C4 7.02554 6.16441 4.55661 9.00419 4.08226C9.54892 3.99127 10 3.55228 10 3C10 2.44772 9.55004 1.99344 9.00199 2.06165C5.05471 2.55286 2 5.9197 2 10C2 14.4183 5.58172 18 10 18C13.6794 18 16.7786 15.5161 17.7123 12.1337C17.8758 11.5415 17.3957 11 16.7814 11Z"
  })), React__default.createElement("span", {
    className: "sr-only"
  }, "Loading...")));
};

var SIZE_DEFAULTS = {
  heightPadding: '',
  widthPadding: '',
  minWidth: '',
  radius: 'rounded-[10px]'
};
var BUTTON_SIZES = {
  SMALL: /*#__PURE__*/_extends$1({}, SIZE_DEFAULTS, {
    heightPadding: 'py-1.5',
    widthPadding: 'px-3.5',
    minWidth: 'min-w-[75px]',
    radius: 'rounded-lg'
  }),
  MEDIUM: /*#__PURE__*/_extends$1({}, SIZE_DEFAULTS, {
    heightPadding: 'py-2.5',
    widthPadding: 'px-4',
    minWidth: 'min-w-[80px]'
  }),
  LARGE: /*#__PURE__*/_extends$1({}, SIZE_DEFAULTS, {
    heightPadding: 'py-3',
    widthPadding: 'px-5',
    minWidth: 'min-w-[95px]'
  }),
  ICON_SMALL: /*#__PURE__*/_extends$1({}, SIZE_DEFAULTS, {
    heightPadding: 'py-2',
    widthPadding: 'px-2'
  }),
  ICON_MEDIUM: /*#__PURE__*/_extends$1({}, SIZE_DEFAULTS, {
    heightPadding: 'py-3',
    widthPadding: 'px-3'
  }),
  ICON_LARGE: /*#__PURE__*/_extends$1({}, SIZE_DEFAULTS, {
    heightPadding: 'py-3.5',
    widthPadding: 'px-3.5'
  }),
  NO_BACKGROUND: /*#__PURE__*/_extends$1({}, SIZE_DEFAULTS, {
    heightPadding: 'py-1',
    widthPadding: 'px-2'
  })
};
var VARIANT_DEFAULTS = {
  defaultColor: '',
  hoverColor: '',
  activeColor: '',
  disabledColor: '',
  textColor: '',
  disabledTextColor: '',
  border: '',
  borderColor: '',
  disabledBorderColor: '',
  noBackground: '',
  isDarkLoader: false,
  focus: 'focus-visible:ring-offset-0 focus-visible:ring-2 focus-visible:ring-teal-300'
};
var BUTTON_VARIANTS = {
  PRIMARY: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'bg-plum-300',
    hoverColor: 'hover:bg-plum-400',
    activeColor: 'active:bg-plum-500',
    disabledColor: 'bg-plum-200',
    textColor: 'text-white'
  }),
  SECONDARY: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'bg-gray-700',
    hoverColor: 'hover:bg-gray-675',
    activeColor: 'active:bg-gray-650',
    disabledColor: 'bg-gray-200',
    textColor: 'text-white',
    disabledTextColor: 'text-gray-500'
  }),
  TERTIARY_FILLED: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'bg-gray-200',
    hoverColor: 'hover:bg-gray-250',
    activeColor: 'active:bg-gray-300',
    disabledColor: 'bg-gray-100',
    textColor: 'text-gray-700',
    disabledTextColor: 'text-gray-500',
    isDarkLoader: true
  }),
  TERTIARY_DARK: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'bg-gray-650',
    hoverColor: 'hover:bg-gray-625',
    activeColor: 'active:bg-gray-600',
    disabledColor: 'bg-gray-650',
    textColor: 'text-white',
    disabledTextColor: 'text-gray-500',
    isDarkLoader: true
  }),
  TERTIARY_OUTLINED: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'bg-white',
    hoverColor: 'hover:bg-gray-100',
    activeColor: 'active:bg-gray-200',
    disabledColor: 'bg-gray-100',
    textColor: 'text-gray-700',
    disabledTextColor: 'text-gray-600',
    border: 'box-border border border-solid',
    borderColor: 'border-gray-400',
    disabledBorderColor: 'border-gray-200',
    isDarkLoader: true
  }),
  TERTIARY_TABLE: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'bg-white',
    hoverColor: 'hover:bg-white',
    activeColor: 'active:bg-gray-200',
    disabledColor: 'bg-gray-100',
    textColor: 'text-gray-700',
    disabledTextColor: 'text-gray-600',
    border: 'hover:border hover:box-border hover:border-solid',
    borderColor: 'hover:border-gray-400',
    disabledBorderColor: 'border-gray-200',
    isDarkLoader: true
  }),
  DESTRUCTIVE: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'bg-red-300',
    hoverColor: 'hover:bg-red-400',
    activeColor: 'active:bg-red-500',
    disabledColor: 'bg-red-100',
    textColor: 'text-white',
    disabledTextColor: 'text-gray-500'
  }),
  ICON: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'text-gray-700',
    hoverColor: 'hover:text-gray-650',
    activeColor: 'active:text-gray-600',
    disabledColor: 'text-gray-300',
    noBackground: 'bg-transparent'
  }),
  SUBDUED_ICON: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'text-gray-600',
    hoverColor: 'hover:text-gray-650',
    activeColor: 'active:text-gray-700',
    disabledColor: 'text-gray-300',
    noBackground: 'bg-transparent'
  }),
  TEXT: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'text-gray-700',
    hoverColor: 'hover:text-gray-650',
    activeColor: 'active:text-gray-600',
    disabledColor: 'text-gray-400',
    noBackground: 'bg-transparent'
  }),
  LINK: /*#__PURE__*/_extends$1({}, VARIANT_DEFAULTS, {
    defaultColor: 'text-teal-300',
    hoverColor: 'hover:text-teal-400',
    activeColor: 'active:text-teal-500',
    disabledColor: 'text-gray-400',
    noBackground: 'bg-transparent'
  })
};

var Button = function Button(_ref) {
  var _cx;
  var hidden = _ref.hidden,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    selected = _ref.selected,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$stopPropagation = _ref.stopPropagation,
    stopPropagation = _ref$stopPropagation === void 0 ? true : _ref$stopPropagation,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'button' : _ref$as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'TERTIARY_FILLED' : _ref$variant,
    _ref$defaultColor = _ref.defaultColor,
    defaultColor = _ref$defaultColor === void 0 ? BUTTON_VARIANTS[variant].defaultColor : _ref$defaultColor,
    _ref$hoverColor = _ref.hoverColor,
    hoverColor = _ref$hoverColor === void 0 ? BUTTON_VARIANTS[variant].hoverColor : _ref$hoverColor,
    _ref$activeColor = _ref.activeColor,
    activeColor = _ref$activeColor === void 0 ? BUTTON_VARIANTS[variant].activeColor : _ref$activeColor,
    _ref$disabledColor = _ref.disabledColor,
    disabledColor = _ref$disabledColor === void 0 ? BUTTON_VARIANTS[variant].disabledColor : _ref$disabledColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? BUTTON_VARIANTS[variant].textColor : _ref$textColor,
    _ref$disabledTextColo = _ref.disabledTextColor,
    disabledTextColor = _ref$disabledTextColo === void 0 ? BUTTON_VARIANTS[variant].disabledTextColor : _ref$disabledTextColo,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? BUTTON_VARIANTS[variant].border : _ref$border,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? BUTTON_VARIANTS[variant].borderColor : _ref$borderColor,
    _ref$disabledBorderCo = _ref.disabledBorderColor,
    disabledBorderColor = _ref$disabledBorderCo === void 0 ? BUTTON_VARIANTS[variant].disabledBorderColor : _ref$disabledBorderCo,
    _ref$noBackground = _ref.noBackground,
    noBackground = _ref$noBackground === void 0 ? BUTTON_VARIANTS[variant].noBackground : _ref$noBackground,
    _ref$isDarkLoader = _ref.isDarkLoader,
    isDarkLoader = _ref$isDarkLoader === void 0 ? BUTTON_VARIANTS[variant].isDarkLoader : _ref$isDarkLoader,
    _ref$focus = _ref.focus,
    focus = _ref$focus === void 0 ? BUTTON_VARIANTS[variant].focus : _ref$focus,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'MEDIUM' : _ref$size,
    _ref$heightPadding = _ref.heightPadding,
    heightPadding = _ref$heightPadding === void 0 ? BUTTON_SIZES[size].heightPadding : _ref$heightPadding,
    _ref$widthPadding = _ref.widthPadding,
    widthPadding = _ref$widthPadding === void 0 ? BUTTON_SIZES[size].widthPadding : _ref$widthPadding,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? BUTTON_SIZES[size].minWidth : _ref$minWidth,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? BUTTON_SIZES[size].radius : _ref$radius;
  var CustomTag = as;
  return React__default.createElement(React__default.Fragment, null, !hidden && React__default.createElement(CustomTag, {
    className: twMergeCustom(cx(defaultColor, hoverColor, activeColor, textColor, borderColor, heightPadding, widthPadding, minWidth, border, focus, noBackground, radius, (_cx = {}, _cx[disabledColor] = disabled, _cx[disabledTextColor] = disabled, _cx[disabledBorderColor] = disabled, _cx['pointer-events-none'] = disabled, _cx), {
      'ring-2': selected,
      'ring-gray-700': selected
    }, 'font-body font-medium inline-block text-2 box-border'), className),
    disabled: disabled || loading,
    onClick: function onClick(e) {
      if (stopPropagation) {
        e.stopPropagation();
      }
      if (!loading) {
        _onClick();
      }
    },
    id: id
  }, loading ? React__default.createElement("div", {
    className: "flex items-center justify-center"
  }, React__default.createElement(Loading, {
    isDark: isDarkLoader
  })) : children));
};

var ActionBar = function ActionBar(_ref) {
  var text = _ref.text,
    isOpen = _ref.isOpen,
    _ref$close = _ref.close,
    close = _ref$close === void 0 ? function () {} : _ref$close,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$buttons = _ref.buttons,
    buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
    selection = _ref.selection,
    className = _ref.className;
  useEffect(function () {
    if (!isOpen) onClose();
  }, [isOpen]);
  return React__default.createElement(Transition, {
    as: Fragment,
    show: isOpen,
    appear: true,
    enter: "transition-opacity duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-500",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, React__default.createElement("div", {
    className: cx("fixed bottom-10 z-10 px-5 py-3 bg-gray-700 w-fit h-fit max-w-full mx-1 rounded-xl text-white shadow-z4 flex justify-between items-center gap-x-2 pointer-events-auto", className)
  }, React__default.createElement(Typography, {
    as: "div",
    weight: "font-medium",
    className: "w-fit h-fit text-center flex items-center mr-28"
  }, text), buttons.map(function (button, i) {
    return React__default.createElement("div", {
      key: i,
      className: "flex flex-row justify-center items-center"
    }, React__default.createElement(Button, {
      size: 'SMALL',
      variant: button.variant,
      hidden: button.hidden,
      disabled: button.disabled,
      loading: button.loading,
      onClick: function onClick() {
        button.onClick(selection);
      }
    }, button.text));
  }), React__default.createElement("div", {
    className: "h-4 w-4 flex ml-3 cursor-pointer",
    onClick: close
  }, React__default.createElement(SvgCloseIcon, {
    className: "text-gray-500 hover:text-gray-400 active:text-gray-300"
  }))));
};

var SIZE_DEFAULTS$1 = {
  fontSize: 'text-2',
  fontWeight: 'font-regular',
  fontType: 'font-body'
};
var BADGE_SIZES = {
  SMALL: /*#__PURE__*/_extends$1({}, SIZE_DEFAULTS$1, {
    heightPadding: '',
    widthPadding: 'px-1.5',
    iconSize: 'w-3.5 h-3.5',
    iconRightMargin: 'ml-1',
    iconLeftMargin: 'mr-1',
    radius: 'rounded-md'
  }),
  MEDIUM: /*#__PURE__*/_extends$1({}, SIZE_DEFAULTS$1, {
    heightPadding: 'py-0.5',
    widthPadding: 'px-2.5',
    iconSize: 'w-4 h-4',
    iconRightMargin: 'ml-1.5',
    iconLeftMargin: 'mr-1.5',
    radius: 'rounded-lg'
  })
};
var BADGE_VARIANTS = {
  GRAY: {
    backgroundColor: 'bg-gray-200',
    textColor: 'text-black'
  },
  GREEN: {
    backgroundColor: 'bg-green-100',
    textColor: 'text-green-500'
  },
  RED: {
    backgroundColor: 'bg-red-100',
    textColor: 'text-red-500'
  },
  ORANGE: {
    backgroundColor: 'bg-orange-100',
    textColor: 'text-orange-500'
  },
  TEAL: {
    backgroundColor: 'bg-teal-100',
    textColor: 'text-teal-500'
  },
  PURPLE: {
    backgroundColor: 'bg-purple-100',
    textColor: 'text-purple-500'
  }
};

var Badge = function Badge(_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "MEDIUM" : _ref$size,
    _ref$stopPropagation = _ref.stopPropagation,
    stopPropagation = _ref$stopPropagation === void 0 ? true : _ref$stopPropagation,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    _ref$iconRightMargin = _ref.iconRightMargin,
    iconRightMargin = _ref$iconRightMargin === void 0 ? BADGE_SIZES[size].iconRightMargin : _ref$iconRightMargin,
    _ref$iconLeftMargin = _ref.iconLeftMargin,
    iconLeftMargin = _ref$iconLeftMargin === void 0 ? BADGE_SIZES[size].iconLeftMargin : _ref$iconLeftMargin,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'GRAY' : _ref$variant,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? BADGE_VARIANTS[variant].backgroundColor : _ref$backgroundColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? BADGE_VARIANTS[variant].textColor : _ref$textColor,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? BADGE_SIZES[size].fontSize : _ref$fontSize,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? BADGE_SIZES[size].fontWeight : _ref$fontWeight,
    _ref$fontType = _ref.fontType,
    fontType = _ref$fontType === void 0 ? BADGE_SIZES[size].fontType : _ref$fontType,
    _ref$heightPadding = _ref.heightPadding,
    heightPadding = _ref$heightPadding === void 0 ? BADGE_SIZES[size].heightPadding : _ref$heightPadding,
    _ref$widthPadding = _ref.widthPadding,
    widthPadding = _ref$widthPadding === void 0 ? BADGE_SIZES[size].widthPadding : _ref$widthPadding,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? BADGE_SIZES[size].iconSize : _ref$iconSize,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? BADGE_SIZES[size].radius : _ref$radius;
  var CustomTag = as;
  return React__default.createElement(CustomTag, {
    className: twMergeCustom(cx(backgroundColor, textColor, heightPadding, widthPadding, radius, fontSize, fontWeight, fontType, className)),
    onClick: function onClick(e) {
      if (stopPropagation) {
        e.stopPropagation();
      }
      _onClick();
    }
  }, React__default.createElement("div", {
    className: "flex flex-row justify-center items-center"
  }, iconLeft && React__default.createElement("span", {
    className: cx('flex', iconLeftMargin, iconSize, textColor)
  }, iconLeft), children, iconRight && React__default.createElement("span", {
    className: cx('flex', iconRightMargin, iconSize, textColor)
  }, iconRight)));
};

/**
 * Reusable Banner component: https://www.figma.com/file/K4TUB3zzsein1tzhAROlp3/Notch-Design-System?node-id=331%3A2266
 */
var EBannerType;
(function (EBannerType) {
  EBannerType["SUCCESS"] = "SUCCESS";
  EBannerType["WARNING"] = "WARNING";
  EBannerType["ERROR"] = "ERROR";
  EBannerType["INFO"] = "INFO";
  EBannerType["SUBDUED"] = "SUBDUED";
})(EBannerType || (EBannerType = {}));
var Banner = function Banner(_ref) {
  var className = _ref.className,
    alertType = _ref.alertType,
    isDismissable = _ref.isDismissable,
    timeoutMS = _ref.timeoutMS,
    title = _ref.title,
    body = _ref.body,
    icon = _ref.icon,
    _onClick = _ref.onClick;
  var _useState = useState(true),
    isVisible = _useState[0],
    setIsVisible = _useState[1];
  var colors;
  switch (alertType) {
    case EBannerType.SUCCESS:
      colors = ['bg-green-100', 'text-green-300', 'text-gray-700', 'text-gray-600', 'text-green-500', 'bg-green-200', 'ring-green-500', 'ring-offset-green-100'];
      break;
    case EBannerType.WARNING:
      colors = ['bg-orange-100', 'text-orange-300', 'text-gray-700', 'text-gray-600', 'text-orange-500', 'bg-orange-200', 'ring-orange-500'];
      break;
    case EBannerType.ERROR:
      colors = ['bg-red-100', 'text-red-300', 'text-gray-700', 'text-gray-600', 'text-red-500', 'bg-red-200', 'ring-red-500', 'ring-offset-red-100'];
      break;
    case EBannerType.SUBDUED:
      colors = ['bg-gray-50', 'text-gray-200', 'text-gray-700', 'text-gray-600', 'text-gray-500', 'bg-gray-100', 'ring-gray-600', 'ring-offset-gray-50'];
      break;
    case EBannerType.INFO:
    default:
      colors = ['bg-teal-100', 'text-teal-300', 'text-gray-700', 'text-gray-600', 'bg-teal-200', 'ring-teal-500', 'ring-offset-teal-100'];
      break;
  }
  var _colors = colors,
    bgColor = _colors[0],
    iconColor = _colors[1],
    tileColor = _colors[2],
    bodyTextColor = _colors[3],
    buttonTextColor = _colors[4],
    hoverColor = _colors[5],
    focusColor = _colors[6],
    focusOffsetColor = _colors[7];
  React__default.useEffect(function () {
    if (timeoutMS && timeoutMS > -1) {
      var onTimeout = function onTimeout() {
        setIsVisible(false);
      };
      setTimeout(onTimeout, timeoutMS);
    }
  }, []);
  return React__default.createElement("div", {
    className: cx("rounded-xl " + bgColor + " p-4", className),
    hidden: !isVisible
  }, React__default.createElement("div", {
    className: "flex"
  }, !!icon && React__default.createElement("div", {
    className: "flex justify-center items-center"
  }, React__default.createElement("div", {
    className: "text-center h-5 w-5 " + iconColor
  }, icon)), React__default.createElement("div", {
    className: "flex flex-col gap-2 ml-3 w-full"
  }, React__default.createElement(Typography, {
    as: "div",
    hidden: !title,
    weight: "font-medium",
    className: "" + tileColor
  }, title), React__default.createElement(Typography, {
    as: "div",
    hidden: !body,
    className: "" + bodyTextColor
  }, body)), isDismissable && React__default.createElement("div", {
    className: "ml-auto pl-3"
  }, React__default.createElement("div", {
    className: "-mx-1.5 -my-1.5"
  }, React__default.createElement("button", {
    type: "button",
    className: "inline-flex rounded-md " + bgColor + " p-1.5 " + buttonTextColor + "\n                                            hover:" + hoverColor + " focus:outline-none focus:ring-2 focus:" + focusColor + "\n                                            focus:ring-offset-2 focus:" + focusOffsetColor,
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
      setIsVisible(false);
    }
  }, React__default.createElement("span", {
    className: "sr-only"
  }, "Dismiss"), React__default.createElement(SvgCloseIcon, {
    className: "h-5 w-5",
    "aria-hidden": "true"
  }))))));
};

var _path$1;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgChevronDownIcon = function SvgChevronDownIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 5.187c.359-.28.9-.242 1.208.085L8 10.027l4.492-4.755a.919.919 0 0 1 1.209-.085c.36.28.4.77.093 1.097L8.65 11.728A.896.896 0 0 1 8 12c-.25 0-.488-.1-.65-.272L2.205 6.284A.729.729 0 0 1 2.3 5.187Z",
    fill: "currentColor"
  })));
};

var Card = function Card(_ref) {
  var chevron = _ref.chevron,
    badgeContent = _ref.badgeContent,
    title = _ref.title,
    description = _ref.description,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$badgeVariant = _ref.badgeVariant,
    badgeVariant = _ref$badgeVariant === void 0 ? 'TEAL' : _ref$badgeVariant,
    _ref$badgeSize = _ref.badgeSize,
    badgeSize = _ref$badgeSize === void 0 ? 'MEDIUM' : _ref$badgeSize;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: "flex p-6 border border-gray-300 rounded-xl flex-col gap-4",
    onClick: function onClick() {
      return _onClick;
    }
  }, !!badgeContent && React__default.createElement("div", null, React__default.createElement(Badge, {
    variant: badgeVariant,
    size: badgeSize
  }, badgeContent)), React__default.createElement("div", {
    className: "flex w-full items-center"
  }, React__default.createElement("div", {
    className: "flex flex-col gap-2"
  }, React__default.createElement(Typography, {
    as: "div",
    weight: "font-medium"
  }, title), React__default.createElement(Typography, {
    as: "div",
    className: "text-gray-600"
  }, description)), chevron && React__default.createElement(SvgChevronDownIcon, {
    className: "w-4 h-4 text-gray-400 ml-auto -rotate-90"
  }))));
};

var _path$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.265 2.749a.885.885 0 0 1 0 1.2L6.43 12.251a.77.77 0 0 1-1.134 0L1.735 8.478a.885.885 0 0 1 0-1.201.77.77 0 0 1 1.133 0l2.995 3.173 7.269-7.701a.77.77 0 0 1 1.133 0Z",
    fill: "currentColor"
  })));
};

var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
    label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange,
    position = _ref.position,
    className = _ref.className,
    labelClassName = _ref.labelClassName,
    disabled = _ref.disabled;
  return React__default.createElement("div", {
    className: twMergeCustom(cx('w-full flex lg:flex-row gap-3 items-center flex-row-reverse lg:justify-start justify-between cursor-pointer', {
      'flex-row-reverse lg:flex-row-reverse lg:justify-between justify-between ': position === 'right',
      'flex-row lg:flex-row lg:justify-start justify-start': position === 'left',
      'flex-col lg:flex-col lg:justify-between justify-between ': position === 'bottom',
      'flex-col-reverse lg:flex-col-reverse lg:justify-between justify-between': position === 'top'
    }), className),
    onClick: function onClick() {
      if (!disabled) {
        onChange(value, !checked);
      }
    }
  }, React__default.createElement("div", {
    className: twMergeCustom(cx('flex items-center justify-center h-6 w-6 rounded-lg border border-gray-400', {
      'bg-gray-700 text-white': checked,
      'bg-gray-100 text-gray-700': disabled
    }))
  }, checked && React__default.createElement(SvgCheckIcon, {
    className: "w-3 h-3"
  })), React__default.createElement(Typography, {
    as: "span",
    className: labelClassName
  }, label));
};

var _excluded = ["as", "className", "fluid"];
var Container = function Container(_ref) {
  var as = _ref.as,
    className = _ref.className,
    _ref$fluid = _ref.fluid,
    fluid = _ref$fluid === void 0 ? false : _ref$fluid,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var Component = as || 'div';
  return React__default.createElement(Component, Object.assign({
    className: cx('mx-auto', className, {
      container: !fluid,
      'w-full': fluid
    })
  }, otherProps));
};

/**
 * Override MUI checkbox with our icons
 */
var DataGridCheckbox = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return React__default.createElement(Checkbox$1, Object.assign({
    ref: ref,
    icon: React__default.createElement("div", {
      className: "checkbox-icon w-5 h-5 border-gray-400 border border-solid rounded-md text-gray-700 absolute bg-white"
    }),
    checkedIcon: React__default.createElement("div", {
      className: "w-5 h-5 border-gray-700 bg-gray-700 border border-solid rounded-md text-white flex justify-center items-center absolute"
    }, React__default.createElement(CheckIcon, {
      className: "w-3 h-3"
    })),
    indeterminateIcon: React__default.createElement("div", {
      className: "w-5 h-5 border-gray-700 bg-gray-700 border border-solid rounded-md text-white flex justify-center items-center font-semibold absolute"
    }, "\u2014")
  }, props));
});
DataGridCheckbox.displayName = 'DataGridCheckbox';

var NotchDataGrid = function NotchDataGrid(props) {
  return React__default.createElement(DataGrid, Object.assign({}, props, {
    getRowClassName: function getRowClassName(params) {
      // Add the 'group' tailwind utility class so styling can be applied to a cell when hovering anywhere on the row
      // See: https://tailwindcss.com/docs/hover-focus-and-other-states#styling-based-on-parent-state
      if (props.getRowClassName) {
        return "group " + props.getRowClassName(params);
      } else {
        return 'group';
      }
    },
    components: _extends$1({
      BaseCheckbox: DataGridCheckbox
    }, props.components),
    sx: _extends$1({
      // Allow overflow for popovers to extend beyond the datagrid
      '& .MuiDataGrid-main': {
        overflow: 'visible'
      },
      '& .MuiDataGrid-virtualScroller': {
        overflowY: 'visible !important',
        minHeight: '500px'
      },
      border: 0,
      '& .MuiDataGrid-iconSeparator': {
        display: 'none'
      },
      '& .MuiCircularProgress-root': {
        color: '#1A1719'
      },
      // Some existing CSS we have somewhere is causing the input and the checkbox icon to be misaligned. Overriding CSS to correct it.
      '& .MuiDataGrid-columnHeaderTitleContainerContent': {
        height: '100%',
        overflow: 'visible'
      },
      '& .MuiCheckbox-root': {
        color: '#1A1719'
      },
      '& .MuiCheckbox-root:hover': {
        'background-color': 'rgba(0,0,0,0)'
      },
      '& .MuiCheckbox-root input': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        margin: 0
      },
      '& .MuiTouchRipple-root': {
        display: 'none'
      },
      '& .MuiDataGrid-checkboxInput': {
        width: '100%',
        height: '100%',
        '&.Mui-disabled .checkbox-icon': {
          cursor: 'default',
          background: '#F6F6F6',
          borderColor: '#E6E6E6'
        }
      },
      '& .MuiDataGrid-cell--withRenderer.MuiDataGrid-cell.overflow-visible': {
        overflow: 'visible'
      },
      '& .MuiDataGrid-row.Mui-selected': {
        'background-color': 'unset'
      },
      '& .MuiDataGrid-row.Mui-selected:hover, & .MuiDataGrid-row:hover': {
        'background-color': '#F6F6F6'
      },
      // change font family to use inter in pagination component
      '& .MuiTablePagination-root *': {
        fontFamily: 'Inter, sans-serif'
      },
      // adding proper padding and border color to cells and headers
      '& .MuiDataGrid-cell': {
        padding: '0 4px',
        // gray-200 color
        borderBottomColor: '#EEEEEE'
      },
      '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaders': {
        padding: '0 2px',
        // gray-200 color
        borderBottomColor: '#EEEEEE'
      },
      '& .MuiDataGrid-footerContainer': {
        // gray-200 color
        borderTopColor: '#EEEEEE'
      },
      //removing focus outline color on click on cell or header
      '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within': {
        outline: 'none'
      }
    }, props.sx)
  }));
};

var _path$3;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    d: "M14 10v.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C12.48 14 11.92 14 10.8 14H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 12.48 2 11.92 2 10.8V10m9.333-4.667L8 2m0 0L4.667 5.333M8 2v8",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
var DragAndDropUpload = function DragAndDropUpload(_ref) {
  var wrapClassName = _ref.wrapClassName,
    className = _ref.className,
    onClick = _ref.onClick,
    onDragOver = _ref.onDragOver,
    onDrop = _ref.onDrop,
    fileTypes = _ref.fileTypes,
    onInputChange = _ref.onInputChange,
    inputRef = _ref.inputRef,
    uploadDesc = _ref.uploadDesc,
    typeDesc = _ref.typeDesc,
    isInvalid = _ref.isInvalid,
    invalidMessage = _ref.invalidMessage,
    disabled = _ref.disabled,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? React__default.createElement(SvgUploadIcon, {
      title: "upload icon",
      className: "w-10 h-10 text-gray-600"
    }) : _ref$icon,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple;
  return React__default.createElement("div", {
    className: cx('w-full', wrapClassName)
  }, React__default.createElement("div", {
    className: cx('rounded-xl border border-dashed border-gray-500 flex items-center p-7 cursor-pointer hover:bg-gray-100 hover:border-solid', className),
    onClick: onClick,
    onDragOver: onDragOver,
    onDrop: onDrop
  }, React__default.createElement("input", {
    type: "file",
    accept: fileTypes,
    multiple: multiple,
    ref: inputRef,
    disabled: disabled,
    onChange: onInputChange,
    style: {
      display: 'none'
    },
    id: "file-upload",
    name: "file-upload"
  }), icon, React__default.createElement("div", {
    className: twMergeCustom(cx("flex flex-col pl-6", {
      'pl-6': Boolean(typeDesc),
      'pl-4': !Boolean(typeDesc),
      'pl-0': !Boolean(uploadDesc || typeDesc || invalidMessage)
    }))
  }, React__default.createElement(Typography, {
    as: "span",
    weight: "font-medium"
  }, uploadDesc), typeDesc && React__default.createElement(Typography, {
    as: "span",
    className: "pt-1 text-gray-600"
  }, typeDesc), isInvalid && React__default.createElement(Typography, {
    as: "span",
    className: "pt-1 text-red-300"
  }, invalidMessage))));
};

var SEPARATOR_VARIANTS = {
  small: 'h-px bg-gray-200',
  large: 'h-2 bg-gray-100'
};

var Separator = function Separator(_ref) {
  var className = _ref.className,
    _ref$hidden = _ref.hidden,
    hidden = _ref$hidden === void 0 ? false : _ref$hidden,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'small' : _ref$variant;
  return React__default.createElement("div", {
    className: twMergeCustom(cx('w-full', SEPARATOR_VARIANTS[variant]), className),
    hidden: hidden
  });
};

/**
 * Helper function that checks the current size (in pixels) of the browser window
 * @returns Current browser window dimensions as {@link WindowSize}
 */
function getWindowSize() {
  var _window = window,
    innerWidth = _window.innerWidth,
    innerHeight = _window.innerHeight;
  return {
    width: innerWidth,
    height: innerHeight
  };
}
/**
 * Hook that gets the current size of the browser window (in pixels), updating the values if the window is resized
 * @returns Current browser window dimensions as {@link WindowSize}
 */
function useWindowSize() {
  var _useState = useState(getWindowSize()),
    windowSize = _useState[0],
    setWindowSize = _useState[1];
  useEffect(function () {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }
    window.addEventListener('resize', handleWindowResize);
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  return windowSize;
}

var useOnClickOutside = function useOnClickOutside(ref, handler, insideSelectors) {
  useEffect(function () {
    var listener = function listener(event) {
      var el = ref == null ? void 0 : ref.current;
      var clickWasWithinInnerComponent = insideSelectors && insideSelectors.some(function (selector) {
        var _event$target;
        return (event == null ? void 0 : event.target) instanceof Element && (event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.closest(selector));
      });
      if (!el || el.contains((event == null ? void 0 : event.target) || null) || clickWasWithinInnerComponent) {
        return;
      }
      handler(event); // Call the handler only if the click is outside of the element passed.
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, insideSelectors]); // Reload only if ref, handler, or insideSelectors changes
};

/**
 * Reusable right-side "drawer" component based on design for AR Notifications feature:
 * https://www.figma.com/file/5H7GsVYiCtjjSwFks37kjI/Centralized-Platform---Redesign?node-id=4666%3A75202&mode=dev
 *
 * @param {string} [className] A `string` for augmenting the styling of the component
 * @param {boolean} [isVisible] A `boolean` to control whether the drawer is currently displayed
 * @param {boolean} [isDismissable] A `boolean` to indicate if there should be a button in the top right to close the drawer
 * @param {() => void} [close] A function to execute when the close button is clicked
 * @param {boolean} [clickOutsideToClose] A `boolean` which, if true, causes any click outside of the drawer to trigger the {@link close} function
 * @param {string[]} [insideSelectors] A `string` array of CSS selectors which will prevent the Drawer from closing if matching elements are clicked on while `clickOutsideToClose` is true (e.g. selector for a modal triggered in the body of the drawer)
 * @param {React.ReactNode} [extraControls] A `ReactNode` for adding small extra controls to the left of the close button (e.g. a "..." button with popover)
 * @param {string} [title] A `string` representing the title to display at the top of the drawer
 * @param {React.ReactNode} [headerContent] A `ReactNode` for additional header content between the title and {@link Separator} (e.g. tabs)
 * @param {boolean} [showHeaderSeparator] A `boolean` to control whether or not a {@link Separator} is rendered between the header and body sections
 * @param {React.ReactNode} [children] `ReactNode` between the opening and closing tags of the Drawer component, used to render the body content
 * @param {React.ReactNode} [footer] A `ReactNode` containing the footer section of the drawer (e.g. "save" and "cancel" buttons)
 */
var Drawer = function Drawer(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$headerClassName = _ref.headerClassName,
    headerClassName = _ref$headerClassName === void 0 ? '' : _ref$headerClassName,
    _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible,
    _ref$isDismissable = _ref.isDismissable,
    isDismissable = _ref$isDismissable === void 0 ? true : _ref$isDismissable,
    _ref$close = _ref.close,
    close = _ref$close === void 0 ? function () {} : _ref$close,
    _ref$clickOutsideToCl = _ref.clickOutsideToClose,
    clickOutsideToClose = _ref$clickOutsideToCl === void 0 ? false : _ref$clickOutsideToCl,
    _ref$insideSelectors = _ref.insideSelectors,
    insideSelectors = _ref$insideSelectors === void 0 ? [] : _ref$insideSelectors,
    _ref$extraControls = _ref.extraControls,
    extraControls = _ref$extraControls === void 0 ? null : _ref$extraControls,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$headerContent = _ref.headerContent,
    headerContent = _ref$headerContent === void 0 ? null : _ref$headerContent,
    _ref$showHeaderSepara = _ref.showHeaderSeparator,
    showHeaderSeparator = _ref$showHeaderSepara === void 0 ? true : _ref$showHeaderSepara,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$footer = _ref.footer,
    footer = _ref$footer === void 0 ? null : _ref$footer;
  var drawerRef = useRef(null);
  var handleClickOutside = function handleClickOutside() {
    if (clickOutsideToClose) {
      close();
    }
  };
  useOnClickOutside(drawerRef, handleClickOutside, insideSelectors);
  var _useWindowSize = useWindowSize(),
    windowHeight = _useWindowSize.height;
  var headerRef = useRef(null);
  var _useState = useState(0),
    headerHeight = _useState[0],
    setHeaderHeight = _useState[1];
  var footerRef = useRef(null);
  var _useState2 = useState(0),
    footerHeight = _useState2[0],
    setFooterHeight = _useState2[1];
  var _useState3 = useState(0),
    bodyHeight = _useState3[0],
    setBodyHeight = _useState3[1];
  useLayoutEffect(function () {
    var measureHeight = function measureHeight() {
      var _headerRef$current$cl, _headerRef$current, _footerRef$current$cl, _footerRef$current;
      setHeaderHeight((_headerRef$current$cl = (_headerRef$current = headerRef.current) == null ? void 0 : _headerRef$current.clientHeight) != null ? _headerRef$current$cl : 0);
      setFooterHeight((_footerRef$current$cl = footerRef == null ? void 0 : (_footerRef$current = footerRef.current) == null ? void 0 : _footerRef$current.clientHeight) != null ? _footerRef$current$cl : 0);
    };
    // Measure height after the browser has painted the changes
    setTimeout(measureHeight, 0);
    // Re-measure height if the window is resized
    window.addEventListener('resize', measureHeight);
    return function () {
      // Cleanup event listener
      window.removeEventListener('resize', measureHeight);
    };
  });
  useLayoutEffect(function () {
    setBodyHeight(windowHeight - headerHeight - footerHeight);
  }, [windowHeight, headerHeight, footerHeight]);
  return React__default.createElement(Transition, {
    show: isVisible,
    enter: "transition ease-in-out duration-300 transform",
    enterFrom: 'translate-x-full',
    enterTo: 'translate-x-0',
    leave: 'transition ease-in-out duration-300 transform',
    leaveFrom: 'translate-x-0',
    leaveTo: 'translate-x-full',
    className: 'sticky top-0'
  }, React__default.createElement("div", {
    ref: drawerRef,
    className: mergeClassNames('min-h-screen w-1/3 fixed right-0 bg-white shadow-z4 flex flex-col z-50', className)
  }, React__default.createElement("div", {
    ref: headerRef,
    className: mergeClassNames('sticky top-0 bg-white z-50', headerClassName)
  }, React__default.createElement("div", {
    className: 'flex flex-row items-center absolute top-6 right-6'
  }, extraControls, isDismissable && React__default.createElement(Button, {
    variant: "ICON",
    size: "NO_BACKGROUND",
    heightPadding: 'py-0',
    widthPadding: 'px-0',
    focus: '',
    onClick: close,
    className: 'flex items-center justify-center rounded-full ml-6'
  }, React__default.createElement(SvgCloseIcon, {
    className: "w-4 h-4 text-gray-600"
  }))), React__default.createElement("div", {
    className: "flex flex-col w-full pt-10"
  }, React__default.createElement(Typography, {
    as: "div",
    hidden: !title,
    variant: '2XL',
    className: 'px-10'
  }, title), headerContent, showHeaderSeparator && React__default.createElement(Separator, {
    variant: 'small',
    className: cx({
      'mt-6': !headerContent
    })
  }))), React__default.createElement("div", {
    style: {
      maxHeight: bodyHeight + "px"
    },
    className: 'flex-1 overflow-auto'
  }, children), !!footer && React__default.createElement("div", {
    ref: footerRef,
    className: 'w-full sticky bottom-0 bg-white shrink-0'
  }, React__default.createElement(Separator, {
    variant: 'small'
  }), footer)));
};

var Dropdown = function Dropdown(_ref) {
  var value = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    onClick = _ref.onClick,
    items = _ref.items,
    hideChevron = _ref.hideChevron,
    preHeader = _ref.preHeader,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'right' : _ref$align,
    _ref$itemsClassName = _ref.itemsClassName,
    itemsClassName = _ref$itemsClassName === void 0 ? '' : _ref$itemsClassName,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return React__default.createElement(Menu, {
    as: "div",
    className: twMergeCustom(cx('relative inline-block text-left font-body', className))
  }, function (_ref2) {
    var open = _ref2.open;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", null, React__default.createElement(Menu.Button, {
      className: twMergeCustom(cx("inline-flex border border-transparent flex gap-2 justify-center items-center w-full shadow-transparent px-4 py-2 text-gray-700 bg-white hover:text-gray-700 hover:bg-gray-100 rounded-xl", {
        'border-teal-250 border shadow-z6 outline-none': open
      })),
      onClick: onClick
    }, React__default.createElement("span", null, value), !hideChevron && React__default.createElement("div", {
      className: "w-4 max-w-none text-gray-500"
    }, React__default.createElement(SvgChevronDownIcon, null)))), React__default.createElement(Transition, {
      as: Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95"
    }, React__default.createElement(Menu.Items, {
      className: cx('origin-top-right right-0 text-gray-700  font-body font-body absolute mt-2 w-auto rounded-md shadow-lg bg-white divide-y divide-gray-600 shadow-3', {
        align: align === 'left' ? 'left-0' : 'right-0'
      }, itemsClassName)
    }, preHeader != null ? preHeader : null, React__default.createElement("div", {
      className: "py-1"
    }, items == null ? void 0 : items.map(function (_ref3) {
      var label = _ref3.label,
        val = _ref3.value,
        isDisabled = _ref3.isDisabled;
      return React__default.createElement(Menu.Item, {
        disabled: isDisabled,
        key: val
      }, function (_ref4) {
        var active = _ref4.active;
        return React__default.createElement("div", {
          onClick: function onClick() {
            return onChange(val);
          },
          role: 'button',
          className: cx(active ? 'bg-gray-100 text-gray-700' : 'text-gray-700', 'group flex items-center px-4 py-2 text-1 no-underline')
        }, React__default.createElement(Typography, {
          as: "div"
        }, label));
      });
    })))));
  });
};

var getIsMobileWidth = function getIsMobileWidth() {
  return window.innerWidth <= 1024;
};
function useIsMobileWidth() {
  var _useState = useState(getIsMobileWidth()),
    isMobileWidth = _useState[0],
    setIsMobileWidth = _useState[1];
  useEffect(function () {
    var onResize = function onResize() {
      setIsMobileWidth(getIsMobileWidth());
    };
    window.addEventListener('resize', debounce(onResize, 100));
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, []);
  return isMobileWidth;
}

var GlobalModal = function GlobalModal(_ref) {
  var children = _ref.children,
    _ref$closeButtonText = _ref.closeButtonText,
    closeButtonText = _ref$closeButtonText === void 0 ? 'Close' : _ref$closeButtonText,
    _ref$closeButtonVaria = _ref.closeButtonVariant,
    closeButtonVariant = _ref$closeButtonVaria === void 0 ? 'SECONDARY' : _ref$closeButtonVaria,
    _ref$desktopCloseButt = _ref.desktopCloseButtonSize,
    desktopCloseButtonSize = _ref$desktopCloseButt === void 0 ? 'MEDIUM' : _ref$desktopCloseButt,
    _ref$mobileCloseButto = _ref.mobileCloseButtonSize,
    mobileCloseButtonSize = _ref$mobileCloseButto === void 0 ? 'LARGE' : _ref$mobileCloseButto,
    _ref$desktopModalWidt = _ref.desktopModalWidth,
    desktopModalWidth = _ref$desktopModalWidt === void 0 ? "lg:w-[750px]" : _ref$desktopModalWidt,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var _useState = useState(true),
    isShowing = _useState[0],
    setIsShowing = _useState[1];
  var isMobileWidth = useIsMobileWidth();
  return React__default.createElement(Transition.Root, {
    show: isShowing,
    as: Fragment
  }, React__default.createElement(Dialog, {
    as: "div",
    className: "relative z-50 h-full w-full",
    onClose: onClose
  }, React__default.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, React__default.createElement("div", {
    className: "fixed shadow-z5"
  })), React__default.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "lg:opacity-0 translate-y-full lg:translate-y-0 lg:scale-95",
    enterTo: "lg:opacity-100 translate-y-0 lg:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "lg:opacity-100 translate-y-0 lg:scale-100",
    leaveTo: "lg:opacity-0 translate-y-full lg:translate-y-0 lg:scale-95"
  }, React__default.createElement("div", {
    className: "flex flex-col justify-end lg:justify-center lg:items-center fixed z-50 inset-0 pt-safe lg:my-20"
  }, React__default.createElement("div", {
    className: "overflow-hidden lg:items-center justify-center text-center w-full " + desktopModalWidth + " relative"
  }, React__default.createElement(Dialog.Panel, {
    className: "w-full h-full relative bg-white rounded-xl text-left shadow-xl transform transition-all lg:w-[750px] overflow-y-auto"
  }, React__default.createElement("div", {
    className: "w-full overflow-y-auto lg:overflow-hidden bg-white lg:rounded-xl"
  }, children), React__default.createElement("div", {
    className: "flex flex-row justify-center items-center pb-10 lg:pb-[67px] px-4"
  }, React__default.createElement(Button, {
    className: "w-full lg:w-auto",
    size: isMobileWidth ? mobileCloseButtonSize : desktopCloseButtonSize,
    variant: closeButtonVariant,
    onClick: function onClick() {
      setIsShowing(false);
    }
  }, closeButtonText))))))));
};

var GlobalModalManager = /*#__PURE__*/function () {
  function GlobalModalManager() {
    this.globalModals = [];
    var body = document.getElementsByTagName('body')[0];
    var globalModalContainer = document.createElement('div');
    globalModalContainer.id = 'global-modal-container-main';
    body.insertAdjacentElement('beforeend', globalModalContainer);
    this.containerRef = globalModalContainer;
  }
  var _proto = GlobalModalManager.prototype;
  _proto.show = function show(options) {
    var globalModal = _extends$1({}, options);
    this.globalModals = [globalModal].concat(this.globalModals);
    this.render(options);
  };
  _proto.render = function render(options) {
    var globalModalRender = React__default.createElement(GlobalModal, Object.assign({}, options));
    ReactDOM.render(globalModalRender, this.containerRef);
  };
  return GlobalModalManager;
}();
var globalModal = /*#__PURE__*/new GlobalModalManager();

var INPUT_DEFAULTS = {
  border: 'border-gray-400 border appearance-none',
  focus: 'focus:border-teal-250 focus:shadow-z6 focus:outline-none',
  disabledStyle: 'disabled:bg-gray-100 disabled:text-gray-500 disabled:placeholder-gray-500',
  padding: 'px-3 py-2.5',
  chevronPadding: 'pr-3',
  backgroundColor: 'bg-white',
  height: 'h-10',
  borderRadius: 'rounded-lg',
  fontWeight: 'font-regular',
  textColor: 'text-gray-700 placeholder:text-gray-600',
  fontSize: 'text-2',
  borderError: 'border-red-300',
  width: 'w-full',
  borderWarning: 'border-orange-300'
};
var INPUT_VARIANTS = {
  'SMALL': /*#__PURE__*/_extends$1({}, INPUT_DEFAULTS, {
    height: 'h-8',
    padding: 'py-1.5 px-2.5',
    chevronPadding: 'pr-2.5'
  }),
  'MEDIUM': /*#__PURE__*/_extends$1({}, INPUT_DEFAULTS),
  'LARGE': /*#__PURE__*/_extends$1({}, INPUT_DEFAULTS, {
    height: 'h-12',
    padding: 'py-3 px-4',
    fontSize: 'text-3',
    chevronPadding: 'pr-4'
  }),
  'ADVANCED_ALTERNATIVE': /*#__PURE__*/_extends$1({}, INPUT_DEFAULTS, {
    height: 'h-[54px]',
    padding: 'px-2.5 pt-6 pb-2'
  })
};
var DEFAULT_WARNING_ADVANCED_ALTERNATIVE_ICON = /*#__PURE__*/React__default.createElement(WarningIcon, {
  className: "h-4 w-4 text-orange-400"
});

var InputAdvancedLabel = function InputAdvancedLabel(_ref) {
  var _cx;
  var id = _ref.id,
    isFocused = _ref.isFocused,
    isWarning = _ref.isWarning,
    disabled = _ref.disabled,
    label = _ref.label,
    labelIcon = _ref.labelIcon,
    className = _ref.className;
  var _INPUT_VARIANTS$ADVAN = INPUT_VARIANTS['ADVANCED_ALTERNATIVE'],
    fontSize = _INPUT_VARIANTS$ADVAN.fontSize,
    fontWeight = _INPUT_VARIANTS$ADVAN.fontWeight;
  return React__default.createElement("label", {
    htmlFor: id,
    className: twMergeCustom(cx('absolute pointer-events-none transition-all duration-200 transform left-2.5 font-body min-w-0', (_cx = {
      'top-2 text-1 font-medium text-gray-600': isFocused,
      'text-orange-300': isWarning && !isFocused
    }, _cx[fontSize + " " + fontWeight + " top-1/2 transform -translate-y-1/2 "] = !isFocused, _cx['text-gray-500'] = disabled, _cx), className))
  }, React__default.createElement("div", {
    className: "flex gap-2 items-center"
  }, React__default.createElement("div", {
    className: "truncate"
  }, label), labelIcon));
};

var EInputType;
(function (EInputType) {
  EInputType["TEXT"] = "text";
  EInputType["CURRENCY"] = "currency";
  EInputType["CURRENCY_TEXT"] = "currencyText";
  EInputType["NUMBER"] = "number";
  EInputType["TEL"] = "tel";
  EInputType["EMAIL"] = "email";
  EInputType["PASSWORD"] = "password";
})(EInputType || (EInputType = {}));
var Input = function Input(_ref) {
  var _cx;
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'MEDIUM' : _ref$variant,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? INPUT_VARIANTS[variant].border : _ref$border,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? INPUT_VARIANTS[variant].height : _ref$height,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? INPUT_VARIANTS[variant].borderRadius : _ref$borderRadius,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? INPUT_VARIANTS[variant].fontWeight : _ref$fontWeight,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? INPUT_VARIANTS[variant].fontSize : _ref$fontSize,
    _ref$focus = _ref.focus,
    focus = _ref$focus === void 0 ? INPUT_VARIANTS[variant].focus : _ref$focus,
    _ref$disabledStyle = _ref.disabledStyle,
    disabledStyle = _ref$disabledStyle === void 0 ? INPUT_VARIANTS[variant].disabledStyle : _ref$disabledStyle,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? INPUT_VARIANTS[variant].padding : _ref$padding,
    _ref$borderError = _ref.borderError,
    borderError = _ref$borderError === void 0 ? INPUT_VARIANTS[variant].borderError : _ref$borderError,
    _ref$borderWarning = _ref.borderWarning,
    borderWarning = _ref$borderWarning === void 0 ? INPUT_VARIANTS[variant].borderWarning : _ref$borderWarning,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? INPUT_VARIANTS[variant].width : _ref$width,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? INPUT_VARIANTS[variant].textColor : _ref$textColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? INPUT_VARIANTS[variant].backgroundColor : _ref$backgroundColor,
    inputClassName = _ref.inputClassName,
    className = _ref.className,
    label = _ref.label,
    labelIcon = _ref.labelIcon,
    placeholder = _ref.placeholder,
    type = _ref.type,
    id = _ref.id,
    required = _ref.required,
    value = _ref.value,
    onChange = _ref.onChange,
    _onBlur = _ref.onBlur,
    isInvalid = _ref.isInvalid,
    invalidMessage = _ref.invalidMessage,
    disabled = _ref.disabled,
    name = _ref.name,
    inputProps = _ref.inputProps,
    helperText = _ref.helperText,
    isWarning = _ref.isWarning,
    inputIcon = _ref.inputIcon,
    _ref$inputIconClassNa = _ref.inputIconClassName,
    inputIconClassName = _ref$inputIconClassNa === void 0 ? '' : _ref$inputIconClassNa,
    _onFocus = _ref.onFocus;
  var inputType = EInputType[type];
  var pattern;
  var icon;
  if (inputType === EInputType.CURRENCY) {
    inputType = EInputType.NUMBER;
    pattern = '^$d{1,3}(,d{3})*(.d+)?$';
    icon = '$';
  }
  if (inputType === EInputType.CURRENCY_TEXT) {
    inputType = EInputType.TEXT;
    icon = '$';
    pattern = '^$d{1,3}(,d{3})*(.d+)?$';
  }
  var isAdvancedField = variant === 'ADVANCED_ALTERNATIVE';
  var showRegularLabel = !isAdvancedField && !!label;
  var initialFocus = isAdvancedField && value !== '';
  var _React$useState = React__default.useState(initialFocus),
    shouldAnimateAdvancedLabel = _React$useState[0],
    setShouldAnimateAdvancedLabel = _React$useState[1];
  var _React$useState2 = React__default.useState(false),
    isInputFocused = _React$useState2[0],
    setIsInputFocused = _React$useState2[1];
  var isWarningEnabled = isAdvancedField && isWarning && !isInvalid;
  useEffect(function () {
    if (isAdvancedField && !isInputFocused && value !== '') {
      setShouldAnimateAdvancedLabel(true);
    }
  }, [value, isAdvancedField, isInputFocused]);
  return React__default.createElement("div", {
    className: twMergeCustom(cx("flex flex-col w-full gap-2", className))
  }, showRegularLabel && React__default.createElement(Typography, {
    as: "div",
    weight: "font-medium",
    className: twMergeCustom(cx(fontSize, "text-gray-700"))
  }, React__default.createElement("label", {
    htmlFor: id
  }, React__default.createElement("div", {
    className: "flex gap-2 items-center"
  }, label, required != null ? required : React__default.createElement("span", {
    className: "text-gray-600 font-regular"
  }, "(optional)"), labelIcon && React__default.createElement("span", {
    className: "flex w-4 h-4"
  }, labelIcon)))), React__default.createElement("div", {
    className: "flex flex-col gap-1"
  }, React__default.createElement("div", {
    className: "relative"
  }, isAdvancedField && label && React__default.createElement(InputAdvancedLabel, {
    label: label,
    labelIcon: labelIcon,
    id: id,
    isFocused: shouldAnimateAdvancedLabel,
    isWarning: isWarningEnabled,
    disabled: disabled,
    className: cx({
      'pr-5': isWarningEnabled || inputIcon
    })
  }), React__default.createElement("input", Object.assign({
    name: name,
    className: twMergeCustom(cx(backgroundColor, border, height, borderRadius, fontWeight, fontSize, focus, disabledStyle, padding, width, textColor, inputClassName, (_cx = {}, _cx[borderError] = isInvalid, _cx[borderWarning] = isWarningEnabled, _cx['pl-6'] = icon, _cx))),
    type: inputType,
    value: value,
    id: id,
    placeholder: placeholder,
    pattern: pattern,
    onFocus: function onFocus(e) {
      if (isAdvancedField) {
        setShouldAnimateAdvancedLabel(true);
      }
      setIsInputFocused(true);
      _onFocus && _onFocus(e);
    },
    onChange: onChange,
    onBlur: function onBlur(e) {
      if (isAdvancedField && e.target.value === '') {
        setShouldAnimateAdvancedLabel(false);
      }
      setIsInputFocused(false);
      _onBlur && _onBlur(e);
    },
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    disabled: disabled
  }, inputProps)), isAdvancedField && React__default.createElement("div", {
    className: twMergeCustom(cx("absolute right-3.5 top-1/2 transform -translate-y-1/2", inputIconClassName))
  }, isWarningEnabled ? DEFAULT_WARNING_ADVANCED_ALTERNATIVE_ICON : inputIcon), icon && React__default.createElement("div", {
    className: twMergeCustom(cx("absolute inset-y-0 left-3 top-0 flex items-center pointer-events-none", {
      'top-4': isAdvancedField,
      'hidden': !shouldAnimateAdvancedLabel && isAdvancedField
    }))
  }, React__default.createElement("span", {
    className: twMergeCustom(cx("text-gray-700 text-2 font-sans font-strong", {
      'text-gray-500': disabled
    }))
  }, icon))), isInvalid && invalidMessage && React__default.createElement(Typography, {
    as: "span",
    variant: "BASE",
    className: "text-red-300"
  }, invalidMessage), helperText && React__default.createElement(Typography, {
    as: "span",
    variant: "LG-1",
    className: "text-gray-600"
  }, helperText)));
};

var MODAL_SIZES = {
  SMALL: {
    closeButtonPositionNoTitle: 'top-5 right-5',
    closeButtonPostionWithTitle: 'top-6 right-5',
    actionButtonPositionNoTitle: 'top-5 right-[52px]',
    actionButtonPositionWithTitle: 'top-6 right-[52px]',
    topPadding: 'pt-5',
    bottomPadding: 'pb-5',
    leftPadding: 'pl-5',
    rightPadding: 'pr-5',
    headerPadding: 'pt-0 pb-5',
    titleAlignment: 'text-left'
  },
  MEDIUM: {
    closeButtonPositionNoTitle: 'top-6 right-6',
    closeButtonPostionWithTitle: 'top-7 right-8',
    actionButtonPositionNoTitle: 'top-6 right-16',
    actionButtonPositionWithTitle: 'top-7 right-16',
    topPadding: 'pt-6',
    bottomPadding: 'pb-6',
    leftPadding: 'pl-8',
    rightPadding: 'pr-8',
    headerPadding: 'pt-0 pb-6',
    titleAlignment: 'text-left'
  },
  LARGE: {
    closeButtonPositionNoTitle: 'top-5 left-4',
    closeButtonPostionWithTitle: 'top-5 left-4',
    actionButtonPositionNoTitle: 'top-5 right-4',
    actionButtonPositionWithTitle: 'top-5 right-4',
    topPadding: 'pt-5',
    bottomPadding: 'pb-12',
    leftPadding: 'pl-4',
    rightPadding: 'pr-4',
    headerPadding: 'pt-10 pb-5',
    titleAlignment: 'text-left'
  },
  LARGE_TITLE_CENTERED: {
    closeButtonPositionNoTitle: 'top-5.5 left-4',
    closeButtonPostionWithTitle: 'top-5.5 left-4',
    actionButtonPositionNoTitle: 'top-5.5 right-4',
    actionButtonPositionWithTitle: 'top-5.5 right-4',
    topPadding: 'pt-5',
    bottomPadding: 'pb-12',
    leftPadding: 'pl-4',
    rightPadding: 'pr-4',
    headerPadding: 'pt-0 pb-5',
    titleAlignment: 'text-center'
  }
};

function onMobileSetLarge(size, onMobileTitleCentered) {
  if (onMobileTitleCentered === void 0) {
    onMobileTitleCentered = false;
  }
  var isMobileWidth = useIsMobileWidth();
  if (isMobileWidth && size === 'MEDIUM' && onMobileTitleCentered === false || isMobileWidth && size === 'SMALL' && onMobileTitleCentered === false) {
    return 'LARGE';
  } else if (isMobileWidth && size === 'MEDIUM' && onMobileTitleCentered === true || isMobileWidth && size === 'SMALL' && onMobileTitleCentered === true) {
    return 'LARGE_TITLE_CENTERED';
  }
  return size;
}
var Modal = function Modal(_ref) {
  var children = _ref.children,
    className = _ref.className,
    isOpen = _ref.isOpen,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    close = _ref.close,
    actionButtonOnClick = _ref.actionButtonOnClick,
    title = _ref.title,
    titleSeparatorDesktop = _ref.titleSeparatorDesktop,
    titleSeparatorMobile = _ref.titleSeparatorMobile,
    description = _ref.description,
    descriptionClassName = _ref.descriptionClassName,
    _ref$descriptionOnMob = _ref.descriptionOnMobile,
    descriptionOnMobile = _ref$descriptionOnMob === void 0 ? false : _ref$descriptionOnMob,
    hideHeader = _ref.hideHeader,
    hideCloseButton = _ref.hideCloseButton,
    _ref$hideActionButton = _ref.hideActionButton,
    hideActionButton = _ref$hideActionButton === void 0 ? true : _ref$hideActionButton,
    actionButtonClassName = _ref.actionButtonClassName,
    closeButtonClassName = _ref.closeButtonClassName,
    icon = _ref.icon,
    _ref$overflowAuto = _ref.overflowAuto,
    overflowAuto = _ref$overflowAuto === void 0 ? false : _ref$overflowAuto,
    _ref$desktopModalWidt = _ref.desktopModalWidth,
    desktopModalWidth = _ref$desktopModalWidt === void 0 ? "lg:w-[600px]" : _ref$desktopModalWidt,
    _ref$modalSize = _ref.modalSize,
    modalSize = _ref$modalSize === void 0 ? onMobileSetLarge('MEDIUM') : _ref$modalSize,
    _ref$closeButtonPosit = _ref.closeButtonPositionWithTitle,
    closeButtonPositionWithTitle = _ref$closeButtonPosit === void 0 ? MODAL_SIZES[modalSize].closeButtonPostionWithTitle : _ref$closeButtonPosit,
    _ref$closeButtonPosit2 = _ref.closeButtonPositionNoTitle,
    closeButtonPositionNoTitle = _ref$closeButtonPosit2 === void 0 ? MODAL_SIZES[modalSize].closeButtonPositionNoTitle : _ref$closeButtonPosit2,
    _ref$actionButtonPosi = _ref.actionButtonPositionWithTitle,
    actionButtonPositionWithTitle = _ref$actionButtonPosi === void 0 ? MODAL_SIZES[modalSize].actionButtonPositionWithTitle : _ref$actionButtonPosi,
    _ref$actionButtonPosi2 = _ref.actionButtonPositionNoTitle,
    actionButtonPositionNoTitle = _ref$actionButtonPosi2 === void 0 ? MODAL_SIZES[modalSize].closeButtonPositionNoTitle : _ref$actionButtonPosi2,
    _ref$leftPadding = _ref.leftPadding,
    leftPadding = _ref$leftPadding === void 0 ? MODAL_SIZES[modalSize].leftPadding : _ref$leftPadding,
    _ref$rightPadding = _ref.rightPadding,
    rightPadding = _ref$rightPadding === void 0 ? MODAL_SIZES[modalSize].rightPadding : _ref$rightPadding,
    _ref$topPadding = _ref.topPadding,
    topPadding = _ref$topPadding === void 0 ? MODAL_SIZES[modalSize].topPadding : _ref$topPadding,
    _ref$bottomPadding = _ref.bottomPadding,
    bottomPadding = _ref$bottomPadding === void 0 ? MODAL_SIZES[modalSize].bottomPadding : _ref$bottomPadding,
    _ref$headerPadding = _ref.headerPadding,
    headerPadding = _ref$headerPadding === void 0 ? MODAL_SIZES[modalSize].headerPadding : _ref$headerPadding,
    _ref$titleAlignment = _ref.titleAlignment,
    titleAlignment = _ref$titleAlignment === void 0 ? MODAL_SIZES[modalSize].titleAlignment : _ref$titleAlignment,
    _ref$initialFocusRef = _ref.initialFocusRef,
    initialFocusRef = _ref$initialFocusRef === void 0 ? useRef(null) : _ref$initialFocusRef;
  var isMobileWidth = useIsMobileWidth();
  var scrollConfig = overflowAuto ? 'lg:overflow-hidden lg:flex lg:flex-col' : 'lg:overflow-auto';
  var closeButtonPosition = !!title ? closeButtonPositionWithTitle : closeButtonPositionNoTitle;
  var actionButtonPosition = !!title ? actionButtonPositionWithTitle : actionButtonPositionNoTitle;
  return React__default.createElement(Transition.Root, {
    show: isOpen,
    as: Fragment
  }, React__default.createElement(Dialog, {
    as: "div",
    className: "relative z-10 h-full w-full",
    initialFocus: initialFocusRef,
    onClose: onClose
  }, React__default.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, React__default.createElement("div", {
    className: "fixed shadow-z5"
  })), React__default.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "lg:opacity-0 translate-y-full lg:translate-y-0 lg:scale-95",
    enterTo: "lg:opacity-100 translate-y-0 lg:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "lg:opacity-100 translate-y-0 lg:scale-100",
    leaveTo: "lg:opacity-0 translate-y-full lg:translate-y-0 lg:scale-95"
  }, React__default.createElement("div", {
    className: cx('flex flex-col justify-end lg:justify-center lg:items-center fixed z-10 inset-0 pt-safe lg:my-20', className)
  }, React__default.createElement("div", {
    className: "overflow-hidden lg:items-center justify-center text-center w-full " + desktopModalWidth + " relative"
  }, !hideActionButton && React__default.createElement(Button, {
    variant: "ICON",
    size: "NO_BACKGROUND",
    onClick: actionButtonOnClick,
    heightPadding: 'py-0',
    widthPadding: 'px-0',
    className: cx('flex absolute z-20 items-center justify-center rounded-full', actionButtonPosition, actionButtonClassName)
  }, React__default.createElement("div", {
    className: cx('text-gray-600 w-5 h-5 lg:w-4 lg:h-4')
  }, icon)), !hideCloseButton && React__default.createElement(Button, {
    variant: "ICON",
    size: "NO_BACKGROUND",
    heightPadding: 'py-0',
    widthPadding: 'px-0',
    focus: '',
    onClick: close,
    className: cx('flex absolute z-20 items-center justify-center rounded-full', closeButtonPosition, closeButtonClassName)
  }, React__default.createElement(SvgCloseIcon, {
    className: "w-5 h-5 lg:w-4 lg:h-4 text-gray-600"
  })), React__default.createElement(Dialog.Panel, {
    className: cx("w-full h-full relative bg-white rounded-xl text-left shadow-xl transform transition-all " + desktopModalWidth + " overflow-y-auto", scrollConfig, bottomPadding)
  }, React__default.createElement("div", {
    className: cx("sticky top-0 z-10 bg-white rounded-xl", leftPadding, rightPadding)
  }, !hideHeader && React__default.createElement("div", {
    className: "" + headerPadding
  }, React__default.createElement("div", {
    className: cx('between items-center lg:justify-between', topPadding)
  }, typeof title === 'string' ? React__default.createElement(Typography, {
    as: 'div',
    variant: 'XL',
    desktopSize: modalSize === 'MEDIUM' ? "lg:text-4" : "lg:text-3",
    weight: 'font-semibold',
    className: "" + titleAlignment
  }, title) : title), (descriptionOnMobile || !isMobileWidth) && (typeof description === 'string' ? React__default.createElement(Typography, {
    as: 'div',
    variant: 'BASE',
    desktopSize: "lg:text-2",
    className: twMergeCustom(cx("text-left text-gray-600 pt-2"), descriptionClassName)
  }, description) : description))), titleSeparatorDesktop && React__default.createElement(Separator, {
    hidden: isMobileWidth
  }), titleSeparatorMobile && React__default.createElement(Separator, {
    hidden: !isMobileWidth
  }), React__default.createElement("div", {
    className: "w-full overflow-y-auto lg:overflow-hidden bg-white lg:rounded-xl"
  }, children)))))));
};

var _path$4, _circle, _circle2, _circle3;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgMoreIcon = function SvgMoreIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    d: "M0 0h16v16H0z"
  })), _circle || (_circle = /*#__PURE__*/createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/createElement("circle", {
    cx: 14,
    cy: 8,
    r: 1.5,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/createElement("circle", {
    cx: 2,
    cy: 8,
    r: 1.5,
    fill: "currentColor"
  })));
};

var defaultButton = /*#__PURE__*/React__default.createElement("div", {
  className: "bg-white flex items-center justify-center h-10 w-10 hover:bg-white lg:hover:bg-gray-100  rounded-xl"
}, /*#__PURE__*/React__default.createElement("div", {
  className: "text-gray-700 w-4 h-4"
}, /*#__PURE__*/React__default.createElement(SvgMoreIcon, null)));
var Popover = function Popover(_ref) {
  var className = _ref.className,
    _ref$header = _ref.header,
    header = _ref$header === void 0 ? '' : _ref$header,
    _ref$headerEnabled = _ref.headerEnabled,
    headerEnabled = _ref$headerEnabled === void 0 ? false : _ref$headerEnabled,
    headerClassName = _ref.headerClassName,
    _ref$headerAs = _ref.headerAs,
    headerAs = _ref$headerAs === void 0 ? 'span' : _ref$headerAs,
    _ref$closePanelOnClic = _ref.closePanelOnClick,
    closePanelOnClick = _ref$closePanelOnClic === void 0 ? true : _ref$closePanelOnClic,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? defaultButton : _ref$button,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    buttonClassName = _ref.buttonClassName,
    popOverClassName = _ref.popOverClassName,
    stopPropagation = _ref.stopPropagation,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? [0, 0] : _ref$offset,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom-end' : _ref$placement,
    parentDivClassName = _ref.parentDivClassName;
  var isMobileWidth = useIsMobileWidth();
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var popoverRef = useRef(null);
  var buttonRef = useRef(null);
  var visibleItems = useMemo(function () {
    return items.filter(function (item) {
      return !item.hidden;
    });
  }, [items]);
  var _React$useState = React__default.useState(null),
    referenceElement = _React$useState[0],
    setReferenceElement = _React$useState[1];
  var _React$useState2 = React__default.useState(null),
    popperElement = _React$useState2[0],
    setPopperElement = _React$useState2[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: placement,
      modifiers: [{
        name: 'offset',
        options: {
          offset: offset
        }
      }, {
        name: 'computeStyles',
        options: {
          adaptive: false
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  useOnClickOutside(popoverRef, function () {
    return setOpen(false);
  });
  /**
   * Clicks outside of the popover or the button close it
   */
  return React__default.createElement("div", {
    ref: setReferenceElement,
    className: parentDivClassName
  }, React__default.createElement("div", {
    className: twMergeCustom(cx('w-auto h-auto group', buttonClassName, {
      'open': open
    })),
    ref: buttonRef,
    onClick: function onClick(e) {
      if (stopPropagation) {
        e.stopPropagation();
      }
      setOpen(!open);
    }
  }, button), React__default.createElement(Popover$1, {
    className: twMergeCustom(cx('relative z-50'), popOverClassName),
    ref: popoverRef
  }, open && React__default.createElement("div", Object.assign({
    style: styles.popper
  }, attributes.popper, {
    ref: setPopperElement
  }), React__default.createElement(Popover$1.Panel, {
    className: twMergeCustom(cx('z-50 bg-gray-200 lg:bg-white lg:shadow-z3 rounded-[10px] overflow-hidden w-[150px] my-2', className)),
    "static": true
  }, React__default.createElement("div", {
    className: "flex flex-col items-start justify-start lg:py-1.5",
    onClick: function onClick(e) {
      if (e && stopPropagation) {
        e.stopPropagation();
      }
      if (closePanelOnClick) {
        setOpen(false);
      }
    }
  }, headerEnabled && React__default.createElement("div", {
    className: twMergeCustom(cx("w-full lg:py-1.5 pt-3 pb-0 lg:px-3.5 px-4", headerClassName))
  }, React__default.createElement(Typography, {
    as: headerAs,
    weight: 'font-regular',
    className: "text-gray-600"
  }, header)), visibleItems.map(function (item, i) {
    return React__default.createElement("div", {
      key: i,
      className: "w-full"
    }, React__default.createElement("div", {
      className: "lg:mx-1",
      onClick: function onClick(e) {
        return item.onClick(e);
      }
    }, React__default.createElement(Typography, {
      as: 'div',
      weight: item.active ? 'font-bold' : 'font-regular',
      className: twMergeCustom(cx(' lg:py-1.5 lg:px-2.5 py-3 px-4 w-full rounded-lg hover:bg-gray-100 lg:active:bg-gray-200 text-gray-700 cursor-pointer', {
        'pointer-events-none text-gray-500': item.disabled
      }, item.className))
    }, item.label)), isMobileWidth && i < visibleItems.length - 1 && React__default.createElement(Separator, {
      className: "bg-gray-400"
    }), !isMobileWidth && item.separatorEnabled && i < visibleItems.length - 1 && React__default.createElement(Separator, {
      className: "bg-gray-200 my-1.5"
    }));
  }))))));
};

var RadioTile = function RadioTile(_ref) {
  var children = _ref.children,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    value = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className,
    disabled = _ref.disabled;
  return React__default.createElement("div", {
    onClick: function onClick() {
      if (!disabled) {
        onChange(value, !selected);
      }
    },
    className: twMergeCustom(cx(' flex gap-3 justify-center items-center w-16 h-10 rounded-xl bg-white text-gray-700 hover:border-gray-500 active:bg-gray-100 cursor-pointer', {
      'border-2 border-gray-700': selected,
      'border border-solid border-gray-400': !selected,
      'bg-gray-100': disabled
    }), className)
  }, children);
};

var NONE_SELECTED = 'none';
var Select = function Select(_ref) {
  var _cx;
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'MEDIUM' : _ref$variant,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? INPUT_VARIANTS[variant].border : _ref$border,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? INPUT_VARIANTS[variant].height : _ref$height,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? INPUT_VARIANTS[variant].borderRadius : _ref$borderRadius,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? INPUT_VARIANTS[variant].fontWeight : _ref$fontWeight,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? INPUT_VARIANTS[variant].fontSize : _ref$fontSize,
    _ref$focus = _ref.focus,
    focus = _ref$focus === void 0 ? INPUT_VARIANTS[variant].focus : _ref$focus,
    _ref$disabledStyle = _ref.disabledStyle,
    disabledStyle = _ref$disabledStyle === void 0 ? INPUT_VARIANTS[variant].disabledStyle : _ref$disabledStyle,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? INPUT_VARIANTS[variant].padding : _ref$padding,
    _ref$chevronPadding = _ref.chevronPadding,
    chevronPadding = _ref$chevronPadding === void 0 ? INPUT_VARIANTS[variant].chevronPadding : _ref$chevronPadding,
    _ref$borderError = _ref.borderError,
    borderError = _ref$borderError === void 0 ? INPUT_VARIANTS[variant].borderError : _ref$borderError,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? INPUT_VARIANTS[variant].width : _ref$width,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? INPUT_VARIANTS[variant].textColor : _ref$textColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? INPUT_VARIANTS[variant].backgroundColor : _ref$backgroundColor,
    inputClassName = _ref.inputClassName,
    className = _ref.className,
    label = _ref.label,
    placeholder = _ref.placeholder,
    options = _ref.options,
    id = _ref.id,
    required = _ref.required,
    value = _ref.value,
    onChange = _ref.onChange,
    isInvalid = _ref.isInvalid,
    invalidMessage = _ref.invalidMessage,
    disabled = _ref.disabled,
    helperText = _ref.helperText,
    selectProps = _ref.selectProps,
    labelIcon = _ref.labelIcon;
  return React__default.createElement("div", {
    className: twMergeCustom(cx("flex flex-col w-full gap-2", className))
  }, !!label && React__default.createElement(Typography, {
    as: "div",
    weight: "font-medium",
    className: twMergeCustom(cx(fontSize, "text-gray-700"))
  }, React__default.createElement("label", {
    htmlFor: id
  }, React__default.createElement("div", {
    className: "flex gap-2 items-center"
  }, label, required != null ? required : React__default.createElement("span", {
    className: "text-gray-600 font-regular"
  }, "(optional)"), labelIcon && React__default.createElement("span", {
    className: "flex w-4 h-4"
  }, labelIcon)))), React__default.createElement("div", {
    className: "flex flex-col gap-1"
  }, React__default.createElement("div", {
    className: "relative"
  }, React__default.createElement("select", Object.assign({
    className: twMergeCustom(cx(backgroundColor, border, height, borderRadius, fontWeight, fontSize, focus, disabledStyle, padding, width, textColor, inputClassName, (_cx = {}, _cx[borderError] = isInvalid, _cx))),
    value: value,
    onChange: onChange,
    id: id,
    "aria-label": ".form-select-lg",
    disabled: disabled
  }, selectProps), React__default.createElement("option", {
    value: NONE_SELECTED
  }, placeholder), options == null ? void 0 : options.map(function (option) {
    return React__default.createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })), React__default.createElement("div", {
    className: cx("pointer-events-none absolute inset-y-0 right-0 flex items-center", chevronPadding)
  }, React__default.createElement(SvgChevronDownIcon, {
    className: "inline-flex w-4 h-4 text-gray-600"
  }))), isInvalid && invalidMessage && React__default.createElement(Typography, {
    as: "span",
    variant: "BASE",
    className: "text-red-300"
  }, invalidMessage), helperText && React__default.createElement(Typography, {
    as: "span",
    variant: "LG-1",
    className: "text-gray-600"
  }, helperText)));
};

var ESkeletonWidths;
(function (ESkeletonWidths) {
  ESkeletonWidths["tiny"] = "w-1/12";
  ESkeletonWidths["small"] = "w-1/4";
  ESkeletonWidths["medium"] = "w-1/2";
  ESkeletonWidths["large"] = "w-3/4";
  ESkeletonWidths["full"] = "w-full";
})(ESkeletonWidths || (ESkeletonWidths = {}));
var Skeleton = function Skeleton(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    className = _ref.className;
  return React__default.createElement("div", {
    className: twMergeCustom(cx('animate-pulse h-6 w-11/12 rounded-md bg-gray-300 ', ESkeletonWidths[size]), className)
  });
};

var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
    value = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className;
  return React__default.createElement("nav", {
    className: twMergeCustom(cx('w-full', className))
  }, React__default.createElement("ul", {
    className: 'flex items-start gap-6 list-none p-0 m-0'
  }, tabs.map(function (tab) {
    return React__default.createElement("li", {
      key: "tab-" + tab,
      className: 'pb-3 relative cursor-pointer',
      onClick: function onClick() {
        return onChange(tab);
      }
    }, React__default.createElement(Typography, {
      as: "span",
      weight: "font-regular",
      className: twMergeCustom(cx('text-gray-600 border-b-2 border-transparent', {
        'text-gray-700 font-medium pb-3 border-gray-700 ': tab === value
      }))
    }, tab));
  })));
};

var Toast = function Toast(_ref) {
  var destroy = _ref.destroy,
    message = _ref.message,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 5000 : _ref$duration,
    _ref$showClose = _ref.showClose,
    showClose = _ref$showClose === void 0 ? true : _ref$showClose,
    icon = _ref.icon,
    action = _ref.action;
  var _useState = useState(true),
    isShowing = _useState[0],
    setIsShowing = _useState[1];
  var hide = function hide() {
    setIsShowing(false);
  };
  useEffect(function () {
    if (duration) {
      var timer = setTimeout(function () {
        hide();
      }, duration);
      return function () {
        clearTimeout(timer);
      };
    }
    return function () {};
  }, [destroy, duration]);
  return React__default.createElement(Transition, {
    as: Fragment,
    show: isShowing,
    appear: true,
    enter: "transition-opacity duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-500",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    afterLeave: destroy
  }, React__default.createElement("div", {
    className: "relative px-4 py-3 bg-gray-700 w-fit h-fit max-w-full mx-1 lg:max-w-md rounded-xl text-white shadow-z4 flex justify-between items-center gap-x-5 overflow-hidden text-ellipsis whitespace-normal pointer-events-auto"
  }, React__default.createElement(Typography, {
    as: "div",
    className: "w-fit h-fit text-center text flex items-center gap-x-2"
  }, icon ? React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: "w-4 h-4 flex"
  }, icon), message) : message), showClose && React__default.createElement("div", {
    className: "h-4 w-4 flex",
    onClick: hide
  }, React__default.createElement(CloseIcon, null)), action && React__default.createElement("div", {
    className: "underline cursor-pointer",
    onClick: function onClick() {
      hide();
      action.onClick();
    }
  }, action.text)));
};

/**
 *
 */
var ToastManager = /*#__PURE__*/function () {
  function ToastManager() {
    this.toasts = [];
    this.currentId = 0;
    var body = document.getElementsByTagName('body')[0];
    var toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container-main';
    body.insertAdjacentElement('beforeend', toastContainer);
    this.containerRef = toastContainer;
  }
  var _proto = ToastManager.prototype;
  _proto.show = function show(options) {
    var _this = this;
    var toastId = this.currentId;
    this.currentId++;
    var toast = _extends$1({}, options, {
      id: toastId,
      destroy: function destroy() {
        return _this.destroy(toastId);
      }
    });
    this.toasts = [toast].concat(this.toasts);
    this.render();
    return toastId;
  };
  _proto.destroy = function destroy(id) {
    this.toasts = this.toasts.filter(function (toast) {
      return toast.id !== id;
    });
    this.render();
  };
  _proto.render = function render() {
    var toastsList = React__default.createElement("div", {
      className: "fixed bottom-2 mb-[60px] lg:mb-0 w-full lg:w-auto lg:bottom-8 lg:right-20 z-50 flex flex-col-reverse content-center items-center lg:items-end p-safe mt-1 lg:mt-4 gap-y-2 pointer-events-none"
    }, this.toasts.map(function (toastProps) {
      return React__default.createElement(Toast, Object.assign({
        key: toastProps.id
      }, toastProps));
    }));
    ReactDOM.render(toastsList, this.containerRef);
  };
  return ToastManager;
}();
var toast = /*#__PURE__*/new ToastManager();

var TOGGLE_SIZES = {
  SMALL: {
    height: 'h-5',
    width: 'w-8',
    circleHeight: 'h-4',
    circleWidth: 'w-4',
    enabledTranslate: 'translate-x-2',
    disabledTranslate: 'translate-x-[-4px]'
  },
  LARGE: {
    height: 'h-8',
    width: 'w-[52px]',
    circleHeight: 'h-7',
    circleWidth: 'w-7',
    enabledTranslate: 'translate-x-4',
    disabledTranslate: 'translate-x-[-4px]'
  }
};
var Toggle = function Toggle(_ref) {
  var isEnabled = _ref.isEnabled,
    _onChange = _ref.onChange,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'SMALL' : _ref$size,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? TOGGLE_SIZES[size].height : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? TOGGLE_SIZES[size].width : _ref$width,
    _ref$circleHeight = _ref.circleHeight,
    circleHeight = _ref$circleHeight === void 0 ? TOGGLE_SIZES[size].circleHeight : _ref$circleHeight,
    _ref$circleWidth = _ref.circleWidth,
    circleWidth = _ref$circleWidth === void 0 ? TOGGLE_SIZES[size].circleWidth : _ref$circleWidth,
    _ref$enabledTranslate = _ref.enabledTranslate,
    enabledTranslate = _ref$enabledTranslate === void 0 ? TOGGLE_SIZES[size].enabledTranslate : _ref$enabledTranslate,
    _ref$disabledTranslat = _ref.disabledTranslate,
    disabledTranslate = _ref$disabledTranslat === void 0 ? TOGGLE_SIZES[size].disabledTranslate : _ref$disabledTranslat,
    className = _ref.className;
  return React__default.createElement(Switch, {
    checked: isEnabled,
    onChange: function onChange() {
      return _onChange(!isEnabled);
    },
    className: twMergeCustom(cx(isEnabled ? 'bg-gray-700' : 'bg-gray-300', "relative inline-flex " + height + " " + width + " py-px px-1.5 items-center rounded-full cursor-pointer ease-in-out duration-200", className))
  }, React__default.createElement("span", {
    "aria-hidden": "true",
    className: cx(isEnabled ? "" + enabledTranslate : "" + disabledTranslate, "pointer-events-none inline-block " + circleHeight + " " + circleWidth + " transform rounded-full bg-white transition ease-in-out duration-200")
  }));
};

var _path$5;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgTooltipArrowIcon = function SvgTooltipArrowIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/createElement("path", {
    d: "M9.629 1.312.846 11H20l-8.894-9.692a1 1 0 0 0-1.477.004Z",
    fill: "currentColor"
  })));
};

var Tooltip = function Tooltip(_ref) {
  var className = _ref.className,
    trigger = _ref.trigger,
    children = _ref.children,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'left' : _ref$placement,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? [0, 12] : _ref$offset,
    _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow,
    arrowClassName = _ref.arrowClassName,
    show = _ref.show,
    onShow = _ref.onShow,
    onHide = _ref.onHide,
    hide = _ref.hide,
    _ref$tooltipClassName = _ref.tooltipClassName,
    tooltipClassName = _ref$tooltipClassName === void 0 ? '' : _ref$tooltipClassName,
    _ref$dismissButton = _ref.dismissButton,
    dismissButton = _ref$dismissButton === void 0 ? false : _ref$dismissButton,
    _ref$dismissButtonTex = _ref.dismissButtonText,
    dismissButtonText = _ref$dismissButtonTex === void 0 ? null : _ref$dismissButtonTex;
  var _React$useState = React__default.useState(null),
    referenceElement = _React$useState[0],
    setReferenceElement = _React$useState[1];
  var _React$useState2 = React__default.useState(null),
    popperElement = _React$useState2[0],
    setPopperElement = _React$useState2[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: placement,
      modifiers: [{
        name: 'preventOverflow',
        options: {
          boundary: 'clippingParents'
        }
      }, {
        name: 'offset',
        options: {
          offset: offset
        }
      }, {
        name: 'hide',
        enabled: false
      }, {
        name: 'computeStyles',
        options: {
          adaptive: false
        }
      }, {
        name: 'arrow',
        options: {
          element: '[data-popper-arrow]',
          padding: 5
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes,
    state = _usePopper.state;
  var showTooltip = function showTooltip() {
    if (onShow) {
      onShow();
    }
  };
  var hideTooltip = function hideTooltip() {
    if (onHide) {
      onHide();
    }
  };
  var hideTooltipOnClick = function hideTooltipOnClick() {
    if (hide) {
      hide();
    }
  };
  var iconRotationClassNames = cx({
    'rotate-90 -right-3 self-center': state == null ? void 0 : state.placement.includes('left'),
    'rotate-[270deg] -left-3 self-center ': state == null ? void 0 : state.placement.includes('right'),
    'rotate-180 -bottom-2 left-0 right-0 mx-auto': state == null ? void 0 : state.placement.includes('top'),
    'rotate-0 -top-2 left-0 right-0 mx-auto ': state == null ? void 0 : state.placement.includes('bottom')
  });
  return React__default.createElement("div", {
    className: twMergeCustom(cx(className, 'relative')),
    ref: setReferenceElement
  }, React__default.createElement("div", {
    ref: setReferenceElement,
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    className: cx('inline-block', className)
  }, trigger), show && React__default.createElement("div", Object.assign({
    style: styles.popper
  }, attributes.popper, {
    ref: setPopperElement,
    className: twMergeCustom(cx('bg-gray-700 z-10 w-auto shadow-z4 rounded-xl p-3 w-max', tooltipClassName))
  }), showArrow && React__default.createElement("div", Object.assign({
    style: styles.arrow
  }, attributes.arrow, {
    className: twMergeCustom(cx('absolute h-full w-full shadow-z4 left-0 top-0 flex -z-[1]', arrowClassName))
  }), React__default.createElement("span", {
    className: cx('w-4 flex transform absolute', iconRotationClassNames)
  }, React__default.createElement(SvgTooltipArrowIcon, null))), React__default.createElement(Typography, {
    as: 'div',
    className: "text-white"
  }, children), dismissButton && React__default.createElement(Button, {
    variant: 'TERTIARY_DARK',
    onClick: hideTooltipOnClick,
    className: 'w-full mt-3'
  }, dismissButtonText)));
};

/* eslint-disable @typescript-eslint/explicit-function-return-type */
var Combobox = function Combobox(_ref) {
  var _cx;
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'MEDIUM' : _ref$variant,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? INPUT_VARIANTS[variant].border : _ref$border,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? INPUT_VARIANTS[variant].height : _ref$height,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? INPUT_VARIANTS[variant].borderRadius : _ref$borderRadius,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? INPUT_VARIANTS[variant].fontWeight : _ref$fontWeight,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? INPUT_VARIANTS[variant].fontSize : _ref$fontSize,
    _ref$focus = _ref.focus,
    focus = _ref$focus === void 0 ? INPUT_VARIANTS[variant].focus : _ref$focus,
    _ref$disabledStyle = _ref.disabledStyle,
    disabledStyle = _ref$disabledStyle === void 0 ? INPUT_VARIANTS[variant].disabledStyle : _ref$disabledStyle,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? INPUT_VARIANTS[variant].padding : _ref$padding,
    _ref$chevronPadding = _ref.chevronPadding,
    chevronPadding = _ref$chevronPadding === void 0 ? INPUT_VARIANTS[variant].chevronPadding : _ref$chevronPadding,
    _ref$borderError = _ref.borderError,
    borderError = _ref$borderError === void 0 ? INPUT_VARIANTS[variant].borderError : _ref$borderError,
    _ref$borderWarning = _ref.borderWarning,
    borderWarning = _ref$borderWarning === void 0 ? INPUT_VARIANTS[variant].borderWarning : _ref$borderWarning,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? INPUT_VARIANTS[variant].width : _ref$width,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? INPUT_VARIANTS[variant].textColor : _ref$textColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? INPUT_VARIANTS[variant].backgroundColor : _ref$backgroundColor,
    _onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$disabledOptions = _ref.disabledOptions,
    disabledOptions = _ref$disabledOptions === void 0 ? false : _ref$disabledOptions,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    options = _ref.options,
    _ref$showChevron = _ref.showChevron,
    showChevron = _ref$showChevron === void 0 ? true : _ref$showChevron,
    inputClassName = _ref.inputClassName,
    optionsClassName = _ref.optionsClassName,
    optionClassName = _ref.optionClassName,
    inputWidth = _ref.inputWidth,
    iconLeft = _ref.iconLeft,
    _ref$iconSelected = _ref.iconSelected,
    iconSelected = _ref$iconSelected === void 0 ? React__default.createElement(CheckIcon, {
      className: twMergeCustom(cx("w-4 h-4"))
    }) : _ref$iconSelected,
    label = _ref.label,
    required = _ref.required,
    labelIcon = _ref.labelIcon,
    className = _ref.className,
    isInvalid = _ref.isInvalid,
    helperText = _ref.helperText,
    _ref$notFoundText = _ref.notFoundText,
    notFoundText = _ref$notFoundText === void 0 ? 'No results found' : _ref$notFoundText,
    isWarning = _ref.isWarning,
    value = _ref.value,
    invalidMessage = _ref.invalidMessage,
    id = _ref.id,
    inputIcon = _ref.inputIcon,
    inputIconClassName = _ref.inputIconClassName,
    _onFocus = _ref.onFocus;
  var initialSelect = options.find(function (option) {
    return option.value === value;
  }) || '';
  var _useState = useState(initialSelect),
    selectedOption = _useState[0],
    setSelectedOption = _useState[1];
  var _useState2 = useState(initialSelect),
    previousSelectedOption = _useState2[0],
    setPreviousSelectedOption = _useState2[1];
  var _useState3 = useState(''),
    query = _useState3[0],
    setQuery = _useState3[1];
  var _React$useState = React__default.useState(!!selectedOption),
    isFocused = _React$useState[0],
    setIsFocused = _React$useState[1];
  var isAdvancedField = variant === 'ADVANCED_ALTERNATIVE';
  var showRegularLabel = !isAdvancedField && !!label;
  var isWarningEnabled = isAdvancedField && isWarning && !isInvalid;
  var filter = query === '' ? options : options.filter(function (option) {
    return option.label.toLowerCase().replace(/\s+/g, '').includes(query.toLowerCase().replace(/\s+/g, ''));
  });
  useEffect(function () {
    if (isAdvancedField && selectedOption) {
      setIsFocused(true);
    }
  }, [selectedOption, isAdvancedField]);
  return React__default.createElement("div", {
    className: twMergeCustom(cx("flex flex-col w-full gap-2", className))
  }, showRegularLabel && React__default.createElement(Typography, {
    as: "div",
    weight: "font-medium",
    variant: "LG-1",
    className: "text-gray-700"
  }, React__default.createElement("label", null, React__default.createElement("div", {
    className: "flex gap-2 items-center"
  }, label, required != null ? required : React__default.createElement("span", {
    className: "text-gray-600"
  }, "(optional)"), labelIcon))), React__default.createElement("div", {
    className: cx('w-full', inputWidth),
    id: id
  }, React__default.createElement(Combobox$1, {
    value: selectedOption,
    onChange: function onChange(option) {
      _onChange(option);
      setSelectedOption(option);
      // this is used to keep track of the previous selected option
      setPreviousSelectedOption(option);
      onBlur && onBlur();
    },
    disabled: disabled
  }, React__default.createElement("div", {
    className: "flex flex-col gap-1"
  }, React__default.createElement("div", {
    className: "relative"
  }, React__default.createElement(Combobox$1.Button, {
    className: "w-full p-0",
    as: "div"
  }, React__default.createElement(Combobox$1.Input, {
    disabled: disabled,
    placeholder: placeholder,
    displayValue: function displayValue(option) {
      var _option$label;
      return (_option$label = option == null ? void 0 : option.label) != null ? _option$label : '';
    },
    onFocus: function onFocus(e) {
      if (isAdvancedField) {
        setIsFocused(true);
      }
      if (_onFocus) {
        _onFocus(e);
      }
      // if the user clicks on the input and the input is not empty, we want to clear the input and the selected option so the user can search again
      if (selectedOption) {
        setQuery('');
        setSelectedOption('');
      }
    },
    onBlur: function onBlur(e) {
      if (isAdvancedField && !selectedOption && e.target.value === '') {
        setIsFocused(false);
      }
      // if the user clicks outside the input and the input is empty, we want to set the previous selected option if it exists
      if (previousSelectedOption && !selectedOption) {
        setSelectedOption(previousSelectedOption);
      }
    },
    className: twMergeCustom(cx('appearance-none truncate pr-6', backgroundColor, border, height, borderRadius, fontWeight, fontSize, focus, disabledStyle, padding, width, textColor, inputClassName, (_cx = {}, _cx[borderError] = isInvalid, _cx[borderWarning] = isWarningEnabled, _cx))),
    onChange: function onChange(event) {
      return setQuery(event.target.value);
    }
  }), React__default.createElement(Combobox$1.Button, {
    as: "span",
    className: cx("pointer-events-none absolute inset-y-0 right-0 flex items-center ", chevronPadding)
  }, showChevron && !isWarningEnabled && React__default.createElement(SvgChevronDownIcon, {
    "aria-hidden": "true",
    className: "h-4 w-4 text-gray-600"
  }))), isAdvancedField && React__default.createElement("div", {
    className: twMergeCustom(cx("absolute right-3.5 h-4 top-1/2 transform -translate-y-1/2", inputIconClassName))
  }, isWarningEnabled ? DEFAULT_WARNING_ADVANCED_ALTERNATIVE_ICON : inputIcon), isAdvancedField && label && React__default.createElement(InputAdvancedLabel, {
    label: label,
    labelIcon: labelIcon,
    isFocused: isFocused,
    isWarning: isWarningEnabled,
    disabled: disabled,
    className: cx("w-[calc(100%_-_2.5rem)]", {
      'pr-5': isWarningEnabled || inputIcon
    })
  }), React__default.createElement(Transition, {
    as: Fragment,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    afterLeave: function afterLeave() {
      return setQuery('');
    }
  }, React__default.createElement(Combobox$1.Options, {
    className: twMergeCustom(cx('absolute py-1.5 px-1 z-50 max-h-48 opacity-100 w-full overflow-auto rounded-[10px] bg-white text-2 font-regular font-body shadow-z3 my-2', optionsClassName))
  }, filter.length === 0 && query !== '' ? React__default.createElement("div", {
    className: "relative cursor-default select-none py-2 px-4 text-gray-700"
  }, notFoundText) : filter.map(function (option, idx) {
    return React__default.createElement("div", {
      key: option.value + "-" + idx
    }, React__default.createElement(Combobox$1.Option, {
      className: function className(_ref2) {
        var active = _ref2.active;
        return cx('relative opacity-100 cursor-default select-none py-1.5 px-2.5 rounded-[10px] list-none hover:bg-gray-100 active:bg-gray-200', {
          'text-gray-500': disabledOptions,
          'bg-gray-200': active
        }, optionClassName);
      },
      value: option,
      disabled: disabledOptions
    }, function (_ref3) {
      var selected = _ref3.selected;
      var isOptionSelected = selected || option.value === (previousSelectedOption == null ? void 0 : previousSelectedOption.value);
      return React__default.createElement("div", {
        className: "flex flex-row justify-between items-center"
      }, React__default.createElement("div", {
        className: "flex flex-row justify-left items-left truncate"
      }, !!iconLeft && React__default.createElement("div", {
        className: 'h-4 w-4 ml-2'
      }, iconLeft), React__default.createElement("div", {
        className: "block truncate font-regular"
      }, option.label)), isOptionSelected && !!iconSelected && React__default.createElement("div", {
        className: 'h-4 w-4'
      }, iconSelected));
    }));
  })))), isInvalid && invalidMessage && React__default.createElement(Typography, {
    as: "span",
    variant: "BASE",
    className: "text-red-300"
  }, invalidMessage), helperText && React__default.createElement(Typography, {
    as: "span",
    variant: "BASE",
    className: "text-gray-600 block"
  }, helperText)))));
};

var css_248z$1 = ".ui-daterangepicker .react-datepicker-wrapper{display:block}.ui-daterangepicker .react-datepicker{background-color:#fff;border:none;font-family:Inter,sans-serif;font-size:14px;font-weight:500}.ui-daterangepicker .react-datepicker__triangle{display:none}.ui-daterangepicker .react-datepicker__month-container{border-radius:10px;box-shadow:0 2px 10px 0 rgba(0,0,0,.1),0 0 2px 0 rgba(0,0,0,.2);padding:16px}.ui-daterangepicker .react-datepicker__month{display:flex;flex-direction:column;gap:8px;margin:0}.ui-daterangepicker .react-datepicker__current-month{font-size:14px;font-weight:500;padding-left:8px;text-align:left}.ui-daterangepicker .react-datepicker__header{background-color:#fff;border-bottom:none;padding-top:0}.ui-daterangepicker .react-datepicker__day-selected{background-color:#1e1e1e!important;color:#fff}.ui-daterangepicker .react-datepicker__day--outside-month:not(.react-datepicker__day--today,.react-datepicker__day--selected,.react-datepicker__day--in-selecting-range,.react-datepicker__day--in-range){color:#a2a2a2}.ui-daterangepicker .react-datepicker__day--today:not(.react-datepicker__day--selected,.react-datepicker__day--in-selecting-range,.react-datepicker__day--in-range){background-color:#eee;color:#111}.ui-daterangepicker .react-datepicker__day-names{display:flex;gap:0 8px;margin-bottom:0;margin-top:16px}.ui-daterangepicker .react-datepicker__day-name{color:#6e6e6e;font-size:12px;font-weight:500;line-height:24px;margin:0;width:24px}.ui-daterangepicker .react-datepicker__week{display:flex;gap:8px}.ui-daterangepicker .react-datepicker__day{background:transparent;border-radius:6px;color:#484848;font-size:14px;font-weight:500;line-height:24px;margin:0;width:24px}.ui-daterangepicker .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-end,.ui-daterangepicker .react-datepicker__day--range-end.react-datepicker__day--in-range,.ui-daterangepicker .react-datepicker__day--selected,.ui-daterangepicker .react-datepicker__day--selected.react-datepicker__day--range-start,.ui-daterangepicker .react-datepicker__day--selected.react-datepicker__day--selecting-range-start{background:#006788;border-radius:6px;color:#fff}.ui-daterangepicker .react-datepicker__day--selected.react-datepicker__day--range-start:after,.ui-daterangepicker .react-datepicker__day--selected.react-datepicker__day--selecting-range-start:after{left:50%}.ui-daterangepicker .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-end:after,.ui-daterangepicker .react-datepicker__day--range-end.react-datepicker__day--in-range:after{right:50%}.ui-daterangepicker .react-datepicker__day--in-range,.ui-daterangepicker .react-datepicker__day--in-selecting-range{background:#e5f0f3;color:#484848;position:relative;transform-style:preserve-3d}.ui-daterangepicker .react-datepicker__day--in-range:after,.ui-daterangepicker .react-datepicker__day--in-selecting-range:after{background:#e5f0f3;bottom:0;content:\"\";left:-4px;position:absolute;right:-4px;top:0;transform:translateZ(-1px)}.ui-daterangepicker .react-datepicker__day--in-range:first-child:after,.ui-daterangepicker .react-datepicker__day--in-selecting-range:first-child:after{left:50%}.ui-daterangepicker .react-datepicker__day--in-range:last-child:after,.ui-daterangepicker .react-datepicker__day--in-selecting-range:last-child:after{right:50%}";
styleInject(css_248z$1,{"insertAt":"top"});

var DateRangePicker = function DateRangePicker(_ref) {
  var initialStartDate = _ref.initialStartDate,
    initialEndDate = _ref.initialEndDate,
    onDateChange = _ref.onDateChange,
    className = _ref.className,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
    onClose = _ref.onClose,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$selectsRange = _ref.selectsRange,
    selectsRange = _ref$selectsRange === void 0 ? true : _ref$selectsRange,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'yyyy-MM-dd' : _ref$dateFormat,
    inputProps = _ref.inputProps,
    renderCustomInputElement = _ref.renderCustomInputElement;
  var ref = useRef(null);
  var inputRef = useRef(null);
  var _useState = useState(initialStartDate ? new Date(initialStartDate) : null),
    startDate = _useState[0],
    setStartDate = _useState[1];
  var _useState2 = useState(initialEndDate ? new Date(initialEndDate) : null),
    endDate = _useState2[0],
    setEndDate = _useState2[1];
  var onChangeRange = function onChangeRange(dates) {
    var start = dates[0],
      end = dates[1];
    setStartDate(start);
    end == null ? void 0 : end.setHours(23, 59, 59, 999);
    setEndDate(end);
    if (onDateChange && start && end) {
      onDateChange(start, end);
    }
  };
  var onChange = function onChange(date) {
    setStartDate(date);
    if (onDateChange && date) {
      onDateChange(date);
    }
  };
  useOnClickOutside(ref, function () {
    if (onClose) {
      onClose();
    }
  });
  var CustomInput = forwardRef(function (_ref2) {
    var props = _extends$1({}, (_objectDestructuringEmpty(_ref2), _ref2));
    return React__default.createElement(React__default.Fragment, null, renderCustomInputElement && renderCustomInputElement(_extends$1({}, props)), !renderCustomInputElement && React__default.createElement(Input, Object.assign({}, inputProps, props)));
  });
  return React__default.createElement("div", {
    className: twMergeCustom(cx('ui-daterangepicker', className)),
    ref: ref
  }, isOpen && React__default.createElement(DatePicker, {
    renderCustomHeader: function renderCustomHeader(_ref3) {
      var decreaseMonth = _ref3.decreaseMonth,
        increaseMonth = _ref3.increaseMonth,
        prevMonthButtonDisabled = _ref3.prevMonthButtonDisabled,
        nextMonthButtonDisabled = _ref3.nextMonthButtonDisabled,
        monthDate = _ref3.monthDate;
      return React__default.createElement("div", {
        className: "flex items-center justify-between"
      }, React__default.createElement(Typography, {
        variant: "LG-1",
        weight: "font-medium",
        className: "text-gray-700 m-0"
      }, monthDate.toLocaleString("en-US", {
        month: "long",
        year: "numeric"
      })), React__default.createElement("div", {
        className: "flex gap-3"
      }, React__default.createElement(Button, {
        className: "p-0 h-4 cursor-pointer",
        onClick: decreaseMonth,
        disabled: prevMonthButtonDisabled,
        variant: "ICON",
        size: "NO_BACKGROUND"
      }, React__default.createElement(ChevronDownIcon, {
        className: "w-4 h-4 text-gray-600 rotate-90"
      })), React__default.createElement(Button, {
        className: "p-0 h-4 cursor-pointer",
        onClick: increaseMonth,
        disabled: nextMonthButtonDisabled,
        variant: "ICON",
        size: "NO_BACKGROUND"
      }, React__default.createElement(ChevronDownIcon, {
        className: "w-4 h-4 text-gray-600 -rotate-90"
      }))));
    },
    selected: startDate,
    dateFormat: dateFormat,
    onChange: selectsRange ? onChangeRange : onChange,
    startDate: startDate,
    endDate: endDate,
    selectsRange: selectsRange,
    inline: inline,
    customInput: React__default.createElement(CustomInput, {
      ref: inputRef
    })
  }));
};

var KEYBOARD_KEYS = {
  ENTER: 'Enter',
  SPACE: ' ',
  ESCAPE: 'Escape',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp'
};
var AutocompletePopover = function AutocompletePopover(props) {
  var _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    itemClassName = props.itemClassName,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'Search' : _props$placeholder,
    _props$inputClassName = props.inputClassName,
    inputClassName = _props$inputClassName === void 0 ? '' : _props$inputClassName,
    _props$separatorClass = props.separatorClassName,
    separatorClassName = _props$separatorClass === void 0 ? '' : _props$separatorClass;
  // State variables
  var _useState = useState(true),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var _useState2 = useState(''),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  var _useState3 = useState(-1),
    focusedItemIndex = _useState3[0],
    setFocusedItemIndex = _useState3[1];
  // Ref variables
  var inputRef = useRef(null);
  var itemsRef = useRef([]);
  // Clears the search query and resets the state of the component.
  var clearQuery = function clearQuery() {
    setIsFocused(false);
    setSearchQuery('');
    setFocusedItemIndex(-1);
  };
  // A list item that is displayed when no search results are found in the list of customers.
  var noResultsInCustomersItem = {
    label: React__default.createElement(Typography, {
      className: "mb-0 ",
      as: "div"
    }, React__default.createElement("span", {
      className: "block"
    }, "No results found")),
    onClick: function onClick() {
      // do nothing
    }
  };
  var scrollToIndex = function scrollToIndex(index) {
    var _itemsRef$current$ind;
    if (!itemsRef.current[index]) {
      return;
    }
    (_itemsRef$current$ind = itemsRef.current[index]) == null ? void 0 : _itemsRef$current$ind.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  };
  var popoverItems = useMemo(function () {
    return items.filter(function (item) {
      return item.searchableField.toLowerCase().includes(searchQuery.toLowerCase());
    }).map(function (item, index, items) {
      return _extends$1({}, item, {
        label: React__default.createElement("div", {
          className: itemClassName,
          role: "button",
          ref: function ref(_ref) {
            itemsRef.current[index] = _ref;
          },
          tabIndex: 0,
          onKeyDown: function onKeyDown(e) {
            if (e.key === KEYBOARD_KEYS.ENTER || e.key === KEYBOARD_KEYS.SPACE) {
              item.onClick();
            } else if (e.key === KEYBOARD_KEYS.ARROW_DOWN) {
              setFocusedItemIndex(function (prevIndex) {
                return Math.min(prevIndex + 1, items.length - 1);
              });
            } else if (e.key === KEYBOARD_KEYS.ARROW_UP) {
              setFocusedItemIndex(function (prevIndex) {
                return Math.max(prevIndex - 1, 0);
              });
            }
          }
        }, item.label),
        className: mergeClassNames(item.className, {
          'bg-gray-100': index === focusedItemIndex
        })
      });
    });
  }, [items, searchQuery, focusedItemIndex]);
  useEffect(function () {
    if (focusedItemIndex !== -1) {
      scrollToIndex(focusedItemIndex);
    }
  }, [focusedItemIndex]);
  var hasItems = popoverItems.length > 0;
  return React__default.createElement(Popover, Object.assign({}, props, {
    header: React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
      className: "relative lg:px-3.5 px-4"
    }, React__default.createElement("div", {
      className: "flex flex-col grow mb-0"
    }, React__default.createElement("div", {
      className: 'relative rounded-lg lg:w-full h-8'
    }, React__default.createElement("div", {
      className: "absolute inset-y-0 left-0 flex items-center pointer-events-none"
    }, React__default.createElement(SearchIcon, {
      className: "inline-flex w-4 h-4 text-gray-600"
    })), React__default.createElement("input", {
      ref: inputRef,
      autoFocus: true,
      onFocus: function onFocus() {
        return setIsFocused(true);
      },
      type: "text",
      onChange: function onChange(e) {
        setSearchQuery(e.target.value);
        // on type change it will remove any existing focused items
        setFocusedItemIndex(-1);
      },
      onKeyDown: function onKeyDown(e) {
        // clears the query search if scape is pressed
        if (e.key === KEYBOARD_KEYS.ESCAPE) {
          clearQuery();
        } else if (e.key === KEYBOARD_KEYS.ENTER && hasItems) {
          if (focusedItemIndex !== -1) {
            var _popoverItems$focused;
            (_popoverItems$focused = popoverItems[focusedItemIndex]) == null ? void 0 : _popoverItems$focused.onClick();
            setFocusedItemIndex(-1);
          }
        } else if (e.key === KEYBOARD_KEYS.ARROW_DOWN && hasItems) {
          e.preventDefault();
          setFocusedItemIndex(function (prevIndex) {
            return (prevIndex + 1) % popoverItems.length;
          });
        } else if (e.key === KEYBOARD_KEYS.ARROW_UP && hasItems) {
          e.preventDefault();
          setFocusedItemIndex(function (prevIndex) {
            return (prevIndex - 1 + popoverItems.length) % popoverItems.length;
          });
        }
      },
      onBlur: function onBlur() {
        if (searchQuery === '' || searchQuery.length === 0) {
          setTimeout(function () {
            return setIsFocused(false);
          });
        }
      },
      value: searchQuery,
      placeholder: placeholder,
      className: mergeClassNames('h-full outline-none block w-full pl-7 pr-10 lg:text-2 text-3 font-regular font-body border-gray-300 rounded-lg placeholder-gray-600 text-gray-700 bg-transparent', inputClassName)
    }), isFocused && (searchQuery == null ? void 0 : searchQuery.length) > 0 && React__default.createElement("div", {
      tabIndex: 0,
      className: "absolute inset-y-0 right-0 flex items-center cursor-pointer",
      onClick: function onClick() {
        var _inputRef$current;
        clearQuery();
        (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus();
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === KEYBOARD_KEYS.ENTER || e.key === KEYBOARD_KEYS.SPACE) {
          var _inputRef$current2;
          clearQuery();
          (_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.focus();
        }
      },
      role: 'button'
    }, React__default.createElement(CloseIcon, {
      className: "inline-flex w-4 h-4 text-gray-600"
    }))))), React__default.createElement(Separator, {
      className: mergeClassNames('mt-px lg:bg-gray-200 bg-gray-400', separatorClassName)
    })),
    headerClassName: 'lg:px-0 px-0 lg:pt-0 lg:pt-0 lg:pb-1.5 pb-1.5',
    headerEnabled: true,
    headerAs: 'div',
    items: hasItems ? popoverItems : [noResultsInCustomersItem],
    closePanelOnClick: false
  }));
};

// TODO: (Vasyl H.) Finalize the constants for the AutocompleteSearch component
var INPUT_DEFAULTS$1 = {
  border: {
    borderColor: 'rgba(216, 216, 216, 1)',
    borderWidth: '1px',
    appearance: 'none',
    outline: 'none'
  },
  focus: {
    '&:focus': {
      borderColor: 'rgba(52, 130, 156, 1)',
      boxShadow: '0px 0px 0px 2px rgba(52, 130, 156, 0.2)',
      outline: 'none'
    }
  },
  disabledStyle: {
    '&:disabled': {
      backgroundColor: '#f7fafc',
      color: '#a0aec0',
      '::placeholder': {
        color: '#a0aec0'
      }
    }
  },
  padding: {
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    paddingTop: '0',
    paddingBottom: '0'
  },
  chevronPadding: {
    paddingRight: '0.75rem'
  },
  backgroundColor: {
    backgroundColor: '#ffffff'
  },
  height: {
    height: '2.5rem'
  },
  borderRadius: {
    borderRadius: '0.5rem'
  },
  fontWeight: {
    fontWeight: 400
  },
  textColor: {
    color: 'rgba(17, 17, 17, 1)',
    '::placeholder': {
      color: '#718096'
    }
  },
  fontSize: {
    fontSize: '0.875rem'
  },
  borderError: {
    borderColor: '#fc8181'
  },
  width: {
    width: '100%'
  },
  borderWarning: {
    borderColor: '#f6ad55'
  }
};
var INPUT_VARIANTS$1 = {
  'SMALL': /*#__PURE__*/_extends$1({}, INPUT_DEFAULTS$1, {
    height: {
      height: '2rem'
    },
    padding: {
      paddingTop: '0',
      paddingBottom: '0',
      paddingLeft: '0.625rem',
      paddingRight: '0.625rem'
    },
    chevronPadding: {
      paddingRight: '0.625rem'
    }
  }),
  'MEDIUM': /*#__PURE__*/_extends$1({}, INPUT_DEFAULTS$1),
  'LARGE': /*#__PURE__*/_extends$1({}, INPUT_DEFAULTS$1, {
    height: {
      height: '3rem'
    },
    padding: {
      paddingTop: '0.75rem',
      paddingBottom: '0.75rem',
      paddingLeft: '1rem',
      paddingRight: '1rem'
    },
    fontSize: {
      fontSize: '1rem'
    },
    chevronPadding: {
      paddingRight: '1rem'
    }
  }),
  'ADVANCED_ALTERNATIVE': /*#__PURE__*/_extends$1({}, INPUT_DEFAULTS$1, {
    height: {
      height: '54px'
    },
    padding: {
      paddingTop: '1.5rem',
      paddingBottom: '0.5rem',
      paddingLeft: '0.625rem',
      paddingRight: '0.625rem'
    }
  })
};

var _excluded$1 = ["searchQuery", "onInputChanged", "optionRenderer", "label", "options", "getOptionLabel", "onOptionSelect", "loading", "inputRenderer", "inputClassName", "className", "customFilterOptions", "autoFocus", "variant"];
var getInputVariantStyles = function getInputVariantStyles(variant) {
  var variantStyles = INPUT_VARIANTS$1[variant];
  return {
    '& .MuiInputBase-root': _extends$1({}, variantStyles.borderRadius, variantStyles.padding, variantStyles.fontWeight, variantStyles.textColor, variantStyles.fontSize, variantStyles.backgroundColor, variantStyles.height, variantStyles.width),
    '& .MuiOutlinedInput-root': {
      '.MuiInputBase-input': {
        padding: '0 0.5rem'
      },
      '& fieldset': _extends$1({}, variantStyles.border),
      '&:hover fieldset': _extends$1({}, variantStyles.border),
      '&.Mui-focused fieldset': _extends$1({}, variantStyles.border, variantStyles.focus['&:focus'])
    }
  };
};
var StyledOptionWrapper = /*#__PURE__*/styled(Box)(function () {
  return {
    '&.MuiAutocomplete-option': {
      padding: '0.2rem',
      '&:hover': {
        backgroundColor: 'teal.100'
      }
    }
  };
});
var AutocompleteSearch = function AutocompleteSearch(_ref) {
  var searchQuery = _ref.searchQuery,
    onInputChanged = _ref.onInputChanged,
    optionRenderer = _ref.optionRenderer,
    options = _ref.options,
    getOptionLabel = _ref.getOptionLabel,
    onOptionSelect = _ref.onOptionSelect,
    loading = _ref.loading,
    inputRenderer = _ref.inputRenderer,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    customFilterOptions = _ref.customFilterOptions,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'MEDIUM' : _ref$variant,
    muiAutocompleteProps = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var handleInputChange = function handleInputChange(_, value) {
    if (onInputChanged) {
      onInputChanged(value);
    }
  };
  var handleOnChange = function handleOnChange(_, value) {
    if (onOptionSelect) {
      onOptionSelect(value);
    }
  };
  return React__default.createElement(Autocomplete, Object.assign({}, muiAutocompleteProps, {
    filterOptions: customFilterOptions ? customFilterOptions : undefined,
    getOptionLabel: getOptionLabel,
    inputValue: searchQuery,
    className: mergeClassNames('w-full', className),
    onInputChange: handleInputChange,
    onChange: handleOnChange,
    loading: loading,
    options: options,
    renderOption: function renderOption(props, option) {
      return React__default.createElement(StyledOptionWrapper, Object.assign({
        component: "li"
      }, props), optionRenderer(option));
    },
    renderInput: function renderInput(params) {
      return inputRenderer ? inputRenderer(params) : React__default.createElement(TextField, Object.assign({}, params, {
        autoFocus: autoFocus,
        InputProps: _extends$1({}, params.InputProps, {
          startAdornment: React__default.createElement(SearchIcon, {
            className: "inline-flex w-4 h-4 text-gray-600"
          }),
          endAdornment: React__default.createElement(React__default.Fragment, null, loading ? React__default.createElement(CircularProgress, {
            color: "inherit",
            size: 18
          }) : null, params.InputProps.endAdornment)
        }),
        sx: getInputVariantStyles(variant)
      }));
    }
  }));
};

var MultiSelectDropdown = function MultiSelectDropdown(_ref) {
  var onChange = _ref.onChange,
    editPattern = _ref.editPattern,
    options = _ref.options,
    defaultValues = _ref.defaultValues,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$allowCreateNewIt = _ref.allowCreateNewItems,
    allowCreateNewItems = _ref$allowCreateNewIt === void 0 ? true : _ref$allowCreateNewIt,
    _ref$notCorrectNewVal = _ref.notCorrectNewValueMessage,
    notCorrectNewValueMessage = _ref$notCorrectNewVal === void 0 ? 'not correct value yet' : _ref$notCorrectNewVal,
    _ref$noOptionsMessage = _ref.noOptionsMessage,
    _noOptionsMessage = _ref$noOptionsMessage === void 0 ? 'No options' : _ref$noOptionsMessage,
    _ref$addNewItemMessag = _ref.addNewItemMessage,
    addNewItemMessage = _ref$addNewItemMessag === void 0 ? 'Press Enter to Add ' : _ref$addNewItemMessag;
  var _useState = useState(options),
    listOptions = _useState[0],
    setListOptions = _useState[1];
  var _useState2 = useState(defaultValues != null ? defaultValues : []),
    selectedOptions = _useState2[0],
    setSelectedOptions = _useState2[1];
  var regexpPattern = editPattern ? new RegExp(editPattern) : new RegExp(/.*/);
  var handleSelectChange = function handleSelectChange(newValue) {
    setSelectedOptions([].concat(newValue));
    onChange([].concat(newValue));
  };
  var handleOnCreate = function handleOnCreate(inputValue) {
    if (inputValue && !listOptions.some(function (opt) {
      return opt.value === inputValue;
    })) {
      var newOption = {
        value: inputValue,
        label: inputValue
      };
      setListOptions([].concat(listOptions, [newOption]));
      var currentSelectedOptions = [].concat(selectedOptions, [newOption]);
      setSelectedOptions(currentSelectedOptions);
      onChange(currentSelectedOptions);
    }
  };
  var validateNewValue = function validateNewValue(inputValue) {
    if (!allowCreateNewItems) {
      return false;
    }
    if (!editPattern) {
      return true;
    }
    return regexpPattern.test(inputValue);
  };
  useEffect(function () {
    setListOptions(options);
    setSelectedOptions(defaultValues != null ? defaultValues : []);
  }, [options]);
  return React__default.createElement(CreatableSelect, {
    className: className,
    isMulti: true,
    value: selectedOptions,
    closeMenuOnSelect: false,
    onChange: handleSelectChange,
    onCreateOption: handleOnCreate,
    formatCreateLabel: !allowCreateNewItems ? function () {
      return null;
    } : function (inputValue) {
      return inputValue && addNewItemMessage + " \"" + inputValue + "\"";
    },
    isValidNewOption: function isValidNewOption(inputValue) {
      return validateNewValue(inputValue);
    },
    noOptionsMessage: function noOptionsMessage(_ref2) {
      var inputValue = _ref2.inputValue;
      return inputValue && allowCreateNewItems ? addNewItemMessage + "  \"" + inputValue + "\"" + (regexpPattern && !regexpPattern.test(inputValue) ? " " + notCorrectNewValueMessage : '') : _noOptionsMessage;
    },
    options: listOptions
  });
};

export { ActionBar, AutocompletePopover, AutocompleteSearch, Badge, Banner, Button, Card, Checkbox, Combobox, Container, DataGridCheckbox, DateRangePicker, DragAndDropUpload, Drawer, Dropdown, EBannerType, EInputType, ESkeletonWidths, GlobalModal, GlobalModalManager, Input, Loading, Modal, MultiSelectDropdown, NONE_SELECTED, NotchDataGrid, Popover, RadioTile, Select, Separator, Skeleton, Tabs, ToastManager, Toggle, Tooltip, Typography, globalModal, mergeClassNames, onMobileSetLarge, toast, twMergeCustom };
//# sourceMappingURL=ui-components.esm.js.map
